import React, { useEffect, useState, useRef } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
// import { Tooltip } from "antd";
import Tooltip from "@mui/material/Tooltip";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import Collapse from "@mui/material/Collapse";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import getSymbolFromCurrency from "currency-symbol-map";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert, __esModule } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetTransactionTypeList,
	getTransactionTypeListDetails
} from "../../redux/actions/getTransactionTypeListAction";

//generateWalletTransactionReportFileAction
import {
	resetGenerateWalletTransactionReportFile,
	generateWalletTransactionReportFileReq
} from "../../redux/actions/generateWalletTransactionReportFileAction";
import {

	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
// import { createFilterOptions } from "@mui/material";
import {
	getWalletTransactionList,
	resetGetWalletTransactionList
} from "../../redux/actions/getWalletTransactionListAction";
import { partnerTransactionSubTypesListReq } from "../../redux/actions/transactionSubTypesPartnerAction";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import { FileExcelFilled, FilePdfFilled } from "@ant-design/icons";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
// import Excel from "../../assets/img/excel.png";
// import Excel from "../../assets/img/Main Icons/excel.png"
import PDF from "../../assets/img/pdf1.png";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import val from "../../getThemeDetails";
import { getCode } from "../../utils/countries";
import { getCodes } from "../../utils/countriesDropdown";
import { getUpdateWalletTransactionStatusLists, resetUpdateWalletTransactionStatus } from "../../redux/actions/updateWalletTransactionStatusPartnerAction"
import {
	Row,
	Col,

	CardBody,
	// CardSubtitle,
	CardTitle,
	CardHeader,
	// Label,
	FormGroup,
	Form,
	// Input,
	CardFooter,
} from "reactstrap";
import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { countries } from "../../utils/countriesDropdown";
// import { getPanelId } from "@mui/material/lab";
// import { resetPartnerGetRefundDetails } from "../../redux/actions/adminGetRefundDetailsAdminAction";
import { partnerGetRefundDetails, resetPartnerGetRefundDetails } from "../../redux/actions/partnerGetRefundDetailsAction";
import { resetAdminCurrencyList } from "../../redux/actions/adminCurrencyListAction"
import { getWalletTransactionListOnParent, resetGetWalletTransactionListOnParent } from "../../redux/actions/getWalletTransactionListOnParentAction";
import { getWalletTransactionListByIDs } from "../../redux/actions/getWalletTransactionListByIDPartnerAction"
import CustomPaginationActionsTable, { TablePaginationActions } from "./TablePaginationCustom";
import { updateFlagsTwoFa } from "../../redux/actions/TwoFactorFlagsUpdateAction";
import { getFeeDetailsByIds } from "../../redux/actions/getFeeDetailsByIdPartnerAction";

import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";
import { FaCheckCircle } from "react-icons/fa"; // For success
import { MdCancel } from "react-icons/md";      // For failed
import { FaClock } from "react-icons/fa6"; // For pending
import { ImSpinner11 } from "react-icons/im"; //for Processing
import { TiCancel } from "react-icons/ti"; //for cancelled
import { MdOutlineCancelPresentation } from "react-icons/md"; //for declined
import { getTransactionCurrencyListAction } from "../../redux/actions/getTransactionCurrencyList";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
const usesTransactionSubTypes = (type) =>
	["PURCHASE", "TRANSACTION", "REFUND", "CHARGEBACK"].includes(
		(type || "").trim().toUpperCase()
	);

const getTransactionTypeLabel = (type) => {
	const value = (type || "").trim().toUpperCase();

	if (value === "PURCHASE") {
		return "Transaction";
	}

	if (value === "PURCHASE FEE") {
		return "Transaction Fee";
	}

	if (value === "PURCHASE AUTH FEE") {
		return "Transaction Auth Fee";
	}

	return type;
};

const getTransactionSubTypeLabel = (type) =>
	(type || "").trim().toUpperCase() === "WALLET" ? "APM" : type;

const getStatusDescriptionLabel = (description) => {
	const labels = {
		PURCHASE: "Transaction",
		"PURCHASE FEE": "Transaction Fee",
		"PURCHASE AUTH FEE": "Transaction Auth Fee",
		"PURCHASE FEE TO UNIPAY": "Transaction Fee to Unipay",
	};

	return labels[(description || "").trim().toUpperCase()] || description;
};

const getTransactionHistoryTypeLabel = (type) => {
	const labels = {
		PURCHASE: "TRANSACTION",
		"PURCHASE FEE": "TRANSACTION FEE",
		"PURCHASE AUTH FEE": "TRANSACTION AUTH FEE",
	};

	return labels[(type || "").trim().toUpperCase()] || type;
};

const getRemarkLabel = (remark) => {
	const labels = {
		PURCHASE: "Transaction",
		"PURCHASE FEE": "Transaction Fee",
		"PURCHASE AUTH FEE": "Transaction Auth Fee",
		"PURCHASE FEE TO UNIPAY": "Transaction Fee to Unipay",
	};

	return labels[(remark || "").trim().toUpperCase()] || remark;
};

// const useRowStyles = makeStyles({
// 	root: {
// 		"& > *": {
// 			borderBottom: "unset",
// 		},
// 	},
// });



const WalletTransaction = () => {


	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [customerId, setCustomerId] = useState("");
	const [invoiceid, setInvoiceid] = useState("")
	const [transactionId, setTransactionId] = useState("");
	const [parentId, setParentId] = useState("");
	const [transactionType, setTransactionType] = useState("");
	const [getTransactionsSubType, setGetTransactionSubType] = useState("");
	const [currency, setCurrency] = useState("");
	const [isFee, setIsFee] = useState("");
	const [getFeeType, setGetFeeType] = useState('')
	// const [open, setOpen] = useState(false);
	// const { row } = props;
	const [viewOpen, setViewOpen] = useState(false);
	const [parentDetailsArr, setParentDetailsArr] = useState([])
	const [parentIdModal, setparentIdModal] = useState(false)
	const [feeDetailsModal, setFeeDetailsModal] = useState(false)
	const [feeDetailsArr, setFeeDetailsArr] = useState([])

	const [customerOrMobName, setCustomerOrMobName] = useState("");
	const [studentId, setstudentId] = useState("")
	const [paymentReference, setpaymentReference] = useState("")
	const [paymentid, setPaymentid] = useState("")

	const [searchLoading, setSearchLoading] = useState(false);

	const login = useSelector((state) => state.login);

	const [getTransactionReportFileResStatus, setGetTransactionReportFileRes] =
		useState(false);
	// const [transactionSubType, setTransactionSubType] = useState("");

	const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
		useState([]);

	const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
		useState(false);


	const [getFeeDetailsListStatus, setGetFeeDetailsListStatus] =
		useState(false);

	const [
		generateWalletTransactionReportFileResStatus,
		setGenerateWalletTransactionReportFileResStatus
	] = useState(false);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [getTransactionSubTypeListResArray, setGetTransactionSubTypeListResArray] =
		useState([]);

	const getPartnerLogin = useSelector(({ login }) => login);
	console.log("getPartnerLoginrole", getPartnerLogin.data.Role)
	const [transactionSubTypesLists, getSetTransactionTypesLists] = useState(false)
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [pageNo, setPageNo] = useState(0)
	const [isSearchClick, setIsSearchClick] = useState(false);
	const hasHandledInitialUpdateStatus = useRef(false);


	// device fingeprint states

	const [density, setdensity] = useState('');
	const [device, setdevice] = useState('');
	const [deviceMemory, setdeviceMemory] = useState('');
	const [deviceUUID, setdeviceUUID] = useState('');
	const [os, setos] = useState('');
	const [osVersion, setosVersion] = useState('');

	// device fingureprint states end

	// const [page, setPage] = useState(0);
	const classes = useStyles();
	// const classes = useRowStyles();


	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;
	console.log("authToken", authToken)

	// const generateWalletTransactionReportFileRes = useSelector(
	// 	({ generateWalletTransactionReportFile }) =>
	// 		generateWalletTransactionReportFile
	// );

	const generateRes = useSelector(
		(state) => state.generateWalletTransactionReportFile
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getTransactionCurrencyListRes = useSelector(
		({ getTransactionCurrencyList }) => getTransactionCurrencyList);

	console.log("getTransactionCurrencyListRes", getTransactionCurrencyListRes)

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getTransactionSubTypesRes = useSelector(
		({ partnerTransactionSubTypesLists }) => partnerTransactionSubTypesLists
	)

	const getUsernameContactSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	const getUsernameSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)

	const partnerUpdateWalletTransactionStatusRes = useSelector(
		({ partnerUpdateWalletTransactionStatusLists }) => partnerUpdateWalletTransactionStatusLists
	)

	const partnerGetRefundDetailsRes = useSelector(
		({ partnerGetRefundDetailsList }) => partnerGetRefundDetailsList
	);
	const partnerGetWalletTransactionListByIdRes = useSelector(
		({ partnerGetWalletTransactionByIdLists }) => partnerGetWalletTransactionByIdLists
	);

	console.log("partnerGetWalletTransactionListByIdRes", partnerGetWalletTransactionListByIdRes)

	const partnerGetFeeDetailsByIDRes = useSelector(
		({ partnerGetFeeDetailsById }) => partnerGetFeeDetailsById
	)

	const getMappedListRes = useSelector(
		({ getMappedList }) => getMappedList
	);
	console.log("getMappedListRes", getMappedListRes)

	const isSubOwner = getPartnerLogin.data.subRole === "SubOwner";




	const hasManualAction = getMappedListRes?.data?.moduleAllocationVO?.masterSubModuleMappingList?.includes("MANUAL ACTION") ?? false;

	const showAction = !isSubOwner || hasManualAction;




	const Theme = useSelector((state) => state.theme.theme);

	// const onButtonClick = () => {
	// 	setOpen(!open);

	// };

	const closeEditModal = () => {
		setViewOpen(false);
		setParentDetails(false)
	}
	// const ViewDetails = (contact) => {
	// 	setViewOpen(true);
	// 	setToCustContact(contact)
	// }
	const [toCustContact, setToCustContact] = useState('')
	const [toBalance, setToBalance] = useState('');
	const [TransactionStatus, setTransactionStatus] = useState('');
	const [ipAdd, setIpAdd] = useState('');
	const [Credit, setCredit] = useState('')
	const [Debit, setDebit] = useState('')
	const [remark, setRemark] = useState('')
	const [toCurrency, setToCurrency] = useState('');
	const [fromCustID, setFromCustID] = useState('');
	const [fromDATE, setFromDATE] = useState('');
	const [IsFees, setIsFees] = useState('');
	const [toCustomerName, setToCustomerName] = useState('');
	const [TransactionAmt, setTransactionAmt] = useState('');
	const [fromCustName, setFromCustName] = useState('')

	const [transStatus, setTransStatus] = useState("");
	const [getCountryCode, setGetCountryCode] = useState("")
	// console.log(transStatus, "transStatus")

	const [toCustName, setToCustName] = useState("")
	const [custContact, setCustContact] = useState("")
	const [isMasked, setIsMasked] = useState(true);
	const [isMaskedToContact, setIsMaskedToContact] = useState(true);
	const [parentDetails, setParentDetails] = useState(false)
	const [openUpdateModal, setOpenUpdateModal] = React.useState(false);
	const [orgnDesc, setorgnDesc] = useState("");
	const [viewUpdateResArray, setViewUpdateResArray] =
		useState([]);
	const [updateStatus, setUpdateStatus] = useState("");
	const [notificationRefundOpen, setNotificationRefundOpen] =
		React.useState(false);

	const [getRefundOpenModal, setGetRefundOpenModal] = useState(false);
	const [getFeeDetailsOpenModal, setGetFeeDetailsOpenModal] = useState(false);

	const [getRemark, setGetRemark] = useState("");
	const [remarkError, setRemarkError] = useState("");

	const [refundFlag, setRefundFlag] = useState(false)
	const [walletOwnerId, setWalletOwnerId] = useState("");
	const [timestamp, setTimestamp] = useState("");

	const hasInitialized = useRef(false);

	const [viewTransactionDetailsResArray, setViewTransactionDetailResArray] =
		useState([]);
	const getWalletTransactionListOnParentRes = useSelector(
		({ getWalletTransactionOnParentList }) => getWalletTransactionOnParentList
	)

	const currencyArray = [].concat(
		getTransactionCurrencyListRes?.data?.currencyList || []
	);

	useEffect(() => {
		if (
			getTransactionCurrencyListRes?.success &&
			getTransactionCurrencyListRes?.data?.status === "success"
		) {
			const currencyArr = [].concat(
				getTransactionCurrencyListRes.data.currencyList || []
			);

			if (currencyArr.length === 1) {
				setCurrency(currencyArr[0]); // ✅ auto select EUR
			}
		}
	}, [getTransactionCurrencyListRes]);


	// const buttondisabling= getWalletTransactionListRes?.data?.transactionList?.[index]?.isFee === "Yes"
	// console.log("buttondisabling",buttondisabling)

	const getTransactionCurrencyListFunc = (walletOwnerIds) => {
		const requestData = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
			},
		};
		console.log("Calling with authToken:", authToken);      // ✅ check token
		console.log("Calling with requestData:", requestData);  // ✅ check request
		dispatch(getTransactionCurrencyListAction(requestData, authToken));
	};

	// useEffect(() => {
	// 	getTransactionCurrencyListFunc();
	// }, [regenerateTokenRes.data.status]); // ✅ wait for token to be ready



	const handleNoticationClose = () => {
		setNotificationRefundOpen(false)
		handleClose()


	};

	// const [getparentId, setGetParentId] = useState('')


	const updateHandleClick = (
		TranID
	) => {
		setorgnDesc(TranID)
		setOpenUpdateModal(true)
		setUpdateStatus('')

	}

	const getUpdateGateWayReq = () => {
		const request = {
			actionCustomerMasterRequestVO: {
				status: updateStatus,
				id: orgnDesc,
				remark: getRemark,
				paymentId: paymentid,
				initiatedBy: "partner",
				walletOwnerId: regenerateTokenRes.data.partnerId
			}

		}
		// console.log("REQUESTTTTTT", request)
		dispatch(getUpdateWalletTransactionStatusLists(request, authToken));
	}

	const getUpdateGateWayFunc = () => {
		// console.log("UPDATEGATEWAYssss", partnerUpdateWalletTransactionStatusRes)
		if (partnerUpdateWalletTransactionStatusRes.data.status === "success") {
			// console.log("INSIDE CONSOLE SUCCESS")
			setViewUpdateResArray(
				partnerUpdateWalletTransactionStatusRes.data
			);
			setNotificationRefundOpen(true)
			getWalletTransactionListReq()
			// setInquiryOpenModal(true)


		}
		if (partnerUpdateWalletTransactionStatusRes.data.status == "Failed") {
			setViewUpdateResArray(partnerUpdateWalletTransactionStatusRes.data);
			setNotificationRefundOpen(true)
			if (
				partnerUpdateWalletTransactionStatusRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, partnerUpdateWalletTransactionStatusRes.data.partnerId);
			}
			if (
				partnerUpdateWalletTransactionStatusRes.data.description == "Authorization failed"
			) {
				// safeRegenerateToken();
			}
		}
		if (partnerUpdateWalletTransactionStatusRes.data.status == "not found") {
			setViewUpdateResArray(partnerUpdateWalletTransactionStatusRes.data);
			setNotificationRefundOpen(true)
			if (
				partnerUpdateWalletTransactionStatusRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, partnerUpdateWalletTransactionStatusRes.data.partnerId);
			}
			if (
				partnerUpdateWalletTransactionStatusRes.data.description == "Authorization failed"
			) {
				// safeRegenerateToken();
			}
		}
		if (partnerUpdateWalletTransactionStatusRes.data.status == "failed") {
			setViewUpdateResArray(partnerUpdateWalletTransactionStatusRes.data);
			setNotificationRefundOpen(true)
			if (
				partnerUpdateWalletTransactionStatusRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, partnerUpdateWalletTransactionStatusRes.data.partnerId);
			}
			if (
				partnerUpdateWalletTransactionStatusRes.data.description == "Authorization failed"
			) {
				// safeRegenerateToken();
			}
		}
	}


	const getRefundDetailsPartnerReq = (walletOwnerId, transactionId) => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: walletOwnerId,
				transactionId: transactionId,
			}
		};

		dispatch(partnerGetRefundDetails(req, authToken))
	};

	useEffect(() => {
		dispatch(resetUpdateWalletTransactionStatus())
	}, [])
	useEffect(() => {
		setNotificationRefundOpen(false)

		return (() => {
			setNotificationRefundOpen(false)
			dispatch(resetUpdateWalletTransactionStatus())

		})
	}, [])



	useEffect(() => {
		if (!hasHandledInitialUpdateStatus.current) {
			hasHandledInitialUpdateStatus.current = true;
			return; // skip whatever stale value is sitting in the store on mount
		}
		if (partnerUpdateWalletTransactionStatusRes.data.status) {
			setNotificationRefundOpen(true)
		}
		getUpdateGateWayFunc();
	}, [partnerUpdateWalletTransactionStatusRes]);



	// useEffect(() => {
	// 	if (partnerUpdateWalletTransactionStatusRes.data.status) {

	// 		setNotificationRefundOpen(true)
	// 	}
	// 	getUpdateGateWayFunc();
	// 	// console.log("inside eff", partnerUpdateWalletTransactionStatusRes);
	// }, [partnerUpdateWalletTransactionStatusRes]);



	// useEffect(() => {
	// 	console.log("partnerUpdateWalletTransactionStatusRessssss", partnerUpdateWalletTransactionStatusRes)
	// 	if (partnerUpdateWalletTransactionStatusRes.data.status) {
	// 		getUpdateGateWayFunc();
	// 	}


	// }, [partnerUpdateWalletTransactionStatusRes]);
	// useEffect(() => {
	// 	// console.log("partnerUpdateWalletTransactionStatusRessssss", partnerUpdateWalletTransactionStatusRes)
	// 	// if (partnerUpdateWalletTransactionStatusRes.data.status) {
	// 	getUpdateGateWayFunc();
	// 	// }


	// }, [partnerUpdateWalletTransactionStatusRes.data.status]);


	// const [showContactNo, setShowContactNo] = useState('')
	// const phoneNumber = "";
	const toggleMask = (fromContact) => {
		//console.log("fromConttttsss", fromContact)
		if (isMasked === true) {
			return "xxx-xxxx"
		}
		//	console.log("seettttIsssMaasskked", isMasked)

	};


	// const maskPhoneNumber = (fromContact) => {

	// 	return 'xxx-xxx-xxxx';
	// };
	const [Curr, setCurr] = useState("");
	const [transId, setTransId] = useState('')
	const [open, setOpen] = useState(null);

	const handleClose = () => {
		setOpenUpdateModal(false)
		setGetFeeDetailsOpenModal(false)
		setGetRefundOpenModal(false)
		setUpdateStatus('')
	}
	const onButtonClick = (transId, Curr) => {
		//console.log("OpenModal", transId)
		//console.log("Opensss", open)
		if (open == transId) {
			setOpen(null)
			setTransId('');   // ← ADD: clear so token refresh doesn't re-fetch
			setCurr('');      // ← ADD: clear so token refresh doesn't re-fetch
		}
		else {
			setIsMasked(true)
			setIsMaskedToContact(true)
			setOpen(transId)
			setTransId(transId)
			setCurr(Curr)
			// console.log("btnnnn", FromCustID)
			getWalletTransactionByIdReq(transId, Curr)
		}

	};

	// const ViewDetails = (
	// 	toCustContact,
	// 	toCustomerName,

	// 	toBalance,
	// 	TransactionStatus,
	// 	ipAdd,
	// 	Credit,
	// 	Debit,
	// 	remark,
	// 	toCurrency,
	// 	fromDATE,
	// 	IsFee,
	// 	TransactionAmt,
	// 	fromCustID,

	// 	fromCustName,
	// 	deviceFingerPrint

	// ) => {
	// 	setToCustContact(toCustContact)
	// 	setToCustomerName(toCustomerName);

	// 	setToBalance(toBalance)
	// 	setTransactionStatus(TransactionStatus)
	// 	setIpAdd(ipAdd);
	// 	setCredit(Credit);
	// 	setDebit(Debit);
	// 	setRemark(remark);
	// 	setToCurrency(toCurrency);
	// 	setFromDATE(fromDATE);
	// 	setIsFees(IsFee);
	// 	setTransactionAmt(TransactionAmt);
	// 	setFromCustID(fromCustID);
	// 	setFromCustName(fromCustName)
	// 	setdensity(deviceFingerPrint ? JSON.parse(deviceFingerPrint).Density : '-');
	// 	setdevice(deviceFingerPrint ? JSON.parse(deviceFingerPrint).Device : '-');
	// 	setdeviceMemory(deviceFingerPrint ? JSON.parse(deviceFingerPrint).Device_Memory : '-');
	// 	setdeviceUUID(deviceFingerPrint ? JSON.parse(deviceFingerPrint).Device_UUID : '-');
	// 	setos(deviceFingerPrint ? JSON.parse(deviceFingerPrint).OS : '-');
	// 	setosVersion(deviceFingerPrint ? JSON.parse(deviceFingerPrint).OS_Version : '-');
	// 	setViewOpen(true)
	// }
	const getWalletTransactionByIdReq = (transId, Curr) => {
		const getGateWayTransactionReq = {
			walletTransactionMasterDetailsRequestVO: {
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				transactionId: transId,
				currency: Curr
			}
		};

		return dispatch(
			getWalletTransactionListByIDs(
				getGateWayTransactionReq,
				regenerateTokenRes.data.AuthToken
			)
		);
		// console.log("///getViewTrans", getGateWayTransactionReq)
		// console.log("emaillllss", viewTransactionDetailsResArray.custEmail)
	};
	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status === "success" && transId && Curr) {
	// 		getWalletTransactionByIdReq(transId, Curr);
	// 	}
	// }, [regenerateTokenRes.data.status]);

	const viewTransactionDetailsResFunc = () => {
		if (partnerGetWalletTransactionListByIdRes.data.status === "success") {
			setViewTransactionDetailResArray(
				partnerGetWalletTransactionListByIdRes.data.transactionMasterDetailsResponseVO
			);
		}
		if (partnerGetWalletTransactionListByIdRes.data.status == "Failed") {
			setViewTransactionDetailResArray(partnerGetWalletTransactionListByIdRes.data);
			if (
				partnerGetWalletTransactionListByIdRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				partnerGetWalletTransactionListByIdRes.data.description == "Authorization failed"
			) {
				// 	safeRegenerateToken();
			}
		}
	};

	useEffect(() => {
		viewTransactionDetailsResFunc();
	}, [partnerGetWalletTransactionListByIdRes.data.status]);
	// console.log("row", row);
	const handleChange = ({ target: { name, value } }) => {
		// if (name === "customerId") {
		// 	// setCustomerId(value);
		// 	Util.verifyNumber(value)
		// 		? setCustomerId(value)
		// 		: setCustomerId(customerId);
		// }

		if (name === "customerId") {
			// console.log("CustIDDDD", customerId)
			setCustomerId(value)
		}

		if (name === "transactionId") {
			// setTransactionId(value);
			Util.verifyNumber(value)
				? setTransactionId(value)
				: setTransactionId(transactionId);
		}

		if (name === "transactionType") {
			//console.log("transssstyyppee", transactionType)
			setTransactionType(value == "Select Transaction Type" ? "" : value);
			// setTransactionType(value);
		}

		if (name === "getTransactionsSubType") {
			setGetTransactionSubType(value == "Select Transaction SubType" ? "" : value);
			// setTransactionType(value);
		}
		if (name === "transStatus") {
			setTransStatus(value);
		}
		if (name === "custContact") {
			setCustContact(value);
		}
		if (name === "toCustName") {
			Util.verifyAlphabet(value)
				? setToCustName(value)
				: setToCustName(toCustName);
			// setToCustName(value);
		}

		if (name === "currency") {
			setCurrency(value == "Select Currency" ? "" : value);
			// setCurrency(value);
		}

		if (name === "isFee") {
			setIsFee(value);
			// setIsFee(value == "All" ? "" : value);
		}
		if (name === "getFeeType") {
			setGetFeeType(value);
			// setIsFee(value == "All" ? "" : value);
		}
		if (name === "toCustContact") {
			setToCustContact(value);
		}
		if (name === "toBalance") {
			setToBalance(value);
		}
		if (name === "TransactionStatus") {
			setTransactionStatus(value);
		}
		if (name === "ipAdd") {
			setIpAdd(value);
		}
		if (name === "Credit") {
			setCredit(value);
		}
		if (name === "Debit") {
			setDebit(value);
		}
		if (name === "remark") {
			setRemark(value);
		}
		if (name === 'density') {
			setdensity(value);
		}
		if (name === 'device') {
			setdevice(value);
		}

		if (name === 'deviceMemory') {
			setdeviceMemory(value);
		}
		if (name === 'deviceUUID') {
			setdeviceUUID(value);
		}
		if (name === 'os') {
			setos(value);
		}
		if (name === 'osVersion') {
			setosVersion(value);
		}
		if (name === "customerOrMobName") {

			//console.log("custttttNammmmee", customerOrMobName)
			setCustomerOrMobName(value)
			// onCustContactFunc(value)


		}
		if (name === "getCountryCode") {
			setGetCountryCode(value);
		}
		if (name === "orgnDesc") {
			//console.log("VALUESSSS", value)
			setorgnDesc(value);
		}
		if (name === "updateStatus") {
			setUpdateStatus(value);
			// setIsFee(value == "All" ? "" : value);
		}
		if (name === "paymentId") {
			setPaymentid(value);
		}
		// if (name === "getRemark") {
		// 	//console.log("VALUESSSS", value)
		// 	setGetRemark(value);
		// }
		if (name === "getRemark") {
			const allowedPattern = /^[a-zA-Z0-9 '"\\-]*$/;

			if (!allowedPattern.test(value)) {
				setRemarkError("Only alphanumeric characters, spaces, ' \" and - are allowed.");
			} else {
				setRemarkError(""); // Clear error
				setGetRemark(value);
			}
		}
		if (name === "invoiceid") {
			setInvoiceid(value)
		}
		if (name == "studentId") {
			setstudentId(value)
		}
		if (name == "paymentreference") {
			setpaymentReference(value)
		}
		// if (name == "timestamp") {
		// 	setTimestamp(value == "Select Timestamp" ? "" : value);
		// }
		if (name === "timestamp") {
			setTimestamp(value == "All" ? "" : value);
		}
		if (name === "parentId") {
			// setTransactionId(value);
			Util.verifyNumber(value)
				? setParentId(value)
				: setParentId(parentId);
		}
	};




	const handleDateChange = (date) => {
		setSelectedDate(date);
		if (date > selectedToDate) {
			setSelectedToDate(date)
		}
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const handleChangePageForward = (event, newPage) => {
		console.log("Arrow", newPage)
		setIsSearchClick(false); // important
		setPageNo(newPage);

		// getWalletTransactionListReq()
		//console.log("Arrow", newPage)
	};

	// const handleChangeRowsPerPage = (event) => {
	// 	const newRowsPerPage = parseInt(event.target.value);
	// 	const newPageNo = Math.floor((pageNo * rowsPerPage) / newRowsPerPage);

	// 	setRowsPerPage(newRowsPerPage);
	// 	setPageNo(newPageNo);

	// 	// setRowsPerPage(parseInt(event.target.value));
	// 	// setPageNo(0);

	// };
	const handleChangeRowsPerPage = (event) => {
		const newRowsPerPage = parseInt(event.target.value, 10);
		const currentFirstRowIndex = pageNo * rowsPerPage;
		const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

		setIsSearchClick(false);

		setRowsPerPage(newRowsPerPage);
		setPageNo(newPage);
	};


	// const handleChangePageForward = (event, newPage, pageNo, records) => {
	// 	setPageNo(newPage + 1);
	// 	getWalletTransactionListReq(newPage + 1, pageNo, records)
	// 	console.log("Arrow", page)
	// };

	// const handleChangePageBackward = (page, records) => {
	// 	console.log("ArrowBackward", page)
	// 	getWalletTransactionListReq(page - 1, records)
	// }
	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(parseInt(event.target.value));
	// 	// setPageNo(0);
	// };
	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	// function countryFlag(cName) {
	// 	console.log("CNAMESSSS", cName)
	// 	console.log("COUNTRYESSSS", countries)
	// 	// const result = countries.filter(coun => coun.name === cName)
	// 	const result = countries.filter((Coun) => Coun.label === cName)


	// 	let country = require("../../assets/img/CountryFlags/" + (result[0].code).toLowerCase() + ".png")
	// 	console.log("CountryFilter", result)

	// 	// console.log("cnnnaaammee", cName)
	// 	return country;
	// }
	// function countryFlag(cNames) {
	// 	// console.log("cnnnaaammee", cNames)
	// 	// console.log("COUNTRYYYYY", country)
	// 	let country = require("../../assets/img/CountryFlags/" + getCode(cNames).toLowerCase() + ".png")
	// 	// console.log("COUNTRYYYYY", country)

	// 	return country;
	// }
	function countryFlag(cNames) {
		// Get the country code
		const countryCode = getCode(cNames);

		// Check if countryCode is null
		if (!countryCode) {

			return null; // or return a default image path if needed
		}

		let country;
		try {
			country = require(`../../assets/img/CountryFlags/${countryCode.toLowerCase()}.png`);
		} catch (err) {

			country = null; // or a default image path if the image cannot be found
		}

		return country;
	}

	// function countryFlagss(cName) {
	// 	// console.log("cnnnaaammee", cNames)
	// 	// console.log("COUNTRYYYYY", country)
	// 	let countrys = require("../../assets/img/CountryFlags/" + getCodes(cName).toLowerCase() + ".png")
	// 	// console.log("COUNTRYYYYY", country)

	// 	return countrys;
	// }
	// const countryFlagss = (cname) => {
	// 	let countrys = require("../../assets/img/CountryFlags/" +
	// 		getCodes(cname).toLowerCase() +
	// 		".png");
	// 	return countrys;
	// };

	// function countryFlagS(cName) {
	// 	cName = cName.replace(/\w+/g,
	// 		function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
	// 	console.log("cnnnaaammee", cName)

	// 	// console.log("COUNTRYYYYY", country)
	// 	let countryS = require("../../assets/img/CountryFlags/" + getCodes(cName).toLowerCase() + ".png")
	// 	// console.log("COUNTRYYYYY", country)

	// 	return countryS;
	// }
	function countryFlagS(cName) {
		//console.log("cnnnaaammee", cName)
		// cName = cName.replace(/\w+/g,
		// 	function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });


		// Check if cName is defined and not an empty string
		if (cName && typeof cName === 'string') {
			cName = cName.replace(/\w+/g, function (w) {
				return w[0].toUpperCase() + w.slice(1).toLowerCase();
			});
		} else {
			return null; // or some default image path if cName is invalid
		}

		let countryS;
		try {
			// countryS = require(`../../assets/img/CountryFlags/${getCodes(cName).toLowerCase()}.png`);
			countryS = require("../../assets/img/CountryFlags/" + getCodes(cName).toLowerCase() + ".png")
		} catch (err) {

			countryS = null; // or a default image path if the image cannot be found
		}
		return countryS;
	}

	// const getCustIdReq = () => {
	// 	const getCustomerIdAndNameReq = {
	// 		loginDetails: {
	// 			walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 		},
	// 		actionCustomerMasterRequestVO: {
	// 			customerNameOrId: ""
	// 		}
	// 	};
	// 	dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken))

	// }

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		getCustIdReq()
	// 	}

	// }, [regenerateTokenRes.data.status])
	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		const getCustomerIdAndNameReq = {
	// 			loginDetails: {
	// 				walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 			},
	// 			actionCustomerMasterRequestVO: {
	// 				customerNameOrId: ""
	// 			}
	// 		};

	// 		dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
	// 	}
	// }, [regenerateTokenRes.data.status]);

	// const onCustContactFunc = (value) => {
	// 	setCustomerOrMobName(value)
	// 	if (value.length >= 3) {
	// 		getuserReq()
	// 	}

	// }

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		const getUserContactReq = {
	// 			actionCustomerMasterRequestVO: {
	// 				customerMobileOrName: customerOrMobName,
	// 				walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 			}
	// 		}
	// 		dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
	// 		// console.log("userContact", getUserContactReq)
	// 	}
	// }, [regenerateTokenRes.data.status])

	// const getuserReq = () => {
	// 	let request = {
	// 		actionCustomerMasterRequestVO: {
	// 			customerMobileOrName: customerOrMobName,
	// 			walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 		}
	// 	}
	// 	dispatch(getUserNameContactSuggestionList(request, authToken))

	// }


	const getWalletTransactionListRes = useSelector(
		({ getWalletTransactionList }) => getWalletTransactionList
	);

	console.log("getWalletTransactionListRes", getWalletTransactionListRes)


	//console.log("getWalletTransactionListRes", getWalletTransactionListRes);
	//console.log("getWalletTransactionListRes");
	const getTransactionTypeList = () => {
		if (getTransactionTypeListRes.data.status == "success") {
			setGetTransactionTypeListResArray(
				getTransactionTypeListRes.data.transactionType
			);
		}
	};
	useEffect(() => {
		getTransactionTypeList();
	}, [getTransactionTypeListRes.data.status]);


	const getTransactionTypeListReqApi = () => {
		const getTransactionTypeListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || login.data.partnerId,
				//subRole : login.data.subRole,
			}
		};
		console.log("auths1", authToken, "this", regenerateTokenRes.data.AuthToken);
		return dispatch(
			getTransactionTypeListDetails(getTransactionTypeListReq, regenerateTokenRes.data.AuthToken ? regenerateTokenRes.data.AuthToken : authToken)
		);
	};

	// useEffect(() => {
	// 	getTransactionTypeListReqApi();
	// }, [regenerateTokenRes.data.status]);

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		getTransactionTypeListReqApi();
	// 	}
	// }, [regenerateTokenRes.data.status]);


	const getTransactionSubTypeListFunc = () => {
		if (transactionSubTypesLists) {
			if (getTransactionSubTypesRes.data.status == "Success") {
				//console.log("subtypesssss", getTransactionSubTypesRes.data.transactionSubtype)
				setGetTransactionSubTypeListResArray(
					getTransactionSubTypesRes.data.transactionSubtype
				);
			}
			if (getTransactionSubTypesRes.data.status == "Failed") {
				setGetTransactionSubTypeListResArray(getTransactionSubTypesRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getTransactionSubTypesRes.data.description
				);
				if (
					getTransactionSubTypesRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getTransactionSubTypesRes.data.description == "Authorization failed"
				) {
					// safeRegenerateToken();
				}
			}
			if (getTransactionSubTypesRes.data.status == "failed") {
				setGetTransactionSubTypeListResArray(getTransactionSubTypesRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getTransactionSubTypesRes.data.description
				);
				if (
					getTransactionSubTypesRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getTransactionSubTypesRes.data.description == "Authorization failed"
				) {
					// safeRegenerateToken();
				}
			}
			if (getTransactionSubTypesRes.data.status == "NOT FOUND") {
				let transactionSubtype = [getTransactionSubTypesRes.data.status]
				setGetTransactionSubTypeListResArray(transactionSubtype);
				// NotificationPopups(
				// 	"error",
				// 	"Failed",
				// 	getTransactionSubTypesRes.data.description
				// );
				if (
					getTransactionSubTypesRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getTransactionSubTypesRes.data.description == "Authorization failed"
				) {
					// safeRegenerateToken();
				}
			}
		}

	};
	const getTransactionSubTypeListReqApi = () => {
		getSetTransactionTypesLists(true)
		const getTransactionSubTypeListReq = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				transactionType: transactionType
			}
		};

		return dispatch(
			partnerTransactionSubTypesListReq(getTransactionSubTypeListReq, authToken)
		);
	};

	// useEffect(() => {
	// 	if (transactionType) {
	// 		getTransactionSubTypeListReqApi()
	// 	}
	// }, [transactionType])

	useEffect(() => {
		if (usesTransactionSubTypes(transactionType)) {
			getTransactionSubTypeListReqApi()
		} else {
			setGetTransactionSubTypeListResArray([]);
		}
	}, [transactionType])


	useEffect(() => {
		getTransactionSubTypeListFunc();
	}, [getTransactionSubTypesRes]);
	useEffect(() => {
		setGetTransactionSubType('')
	}, [transactionType])


	const getWalletTransactionListOnParentReq = (parentId) => {
		setIsLoading(true);
		// setDownloadBtn(true);
		setGetWalletTransactionListStatus(true);
		const getTransactionTypeListReqIs = {
			walletTransactionMasterDetailsRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",

				currency: currency,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: parentId,
				isFee: "",
				transactionType:
					"",
				// walletCustomerId: fromCustomerId,
				walletCustomerId: "",
				toCustomerName: "",
				toCustomerContact: "",
				status: "",
				transactionSubType:
					""
				,
				feeType: "",
				timestamp: ""
			},
		};
		return dispatch(
			getWalletTransactionListOnParent(getTransactionTypeListReqIs, authToken)
		);
	};







	useEffect(() => {
		//console.log("partnerGetRefundDetailsRestttt", partnerGetRefundDetailsRes);

		if (partnerGetRefundDetailsRes.data.status) {
			partnerGetRefundDetailsFunc()
		}
		// return ()=>{
		// setGetRefundOpenModal(false);

		//   dispatch(resetPartnerGetRefundDetails())
		// }
	}, [partnerGetRefundDetailsRes])



	const partnerGetRefundDetailsFunc = () => {
		if (partnerGetRefundDetailsRes.data.status === "success") {
			// setGetRefundOpenModal(true);
			setRefundFlag(true)
		}
		if (partnerGetRefundDetailsRes.data.status == "failed" || partnerGetRefundDetailsRes.data.status == "Failed") {
			//   setCustomerOrMobName(partnerGetRefundDetailsRes.data);
			// setGetRefundOpenModal(true);
			setRefundFlag(false)

			if (
				partnerGetRefundDetailsRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				partnerGetRefundDetailsRes.data.description ==
				"Authorization failed"
			) {
				// safeRegenerateToken();
			}
			if (partnerGetRefundDetailsRes.data.status === "Not found") {
				setCustomerOrMobName([]);
			}
		}
	};



	const handleParentOpen = (parentid) => {
		// console.log("TRANSIIDDDD", transactionId)
		// setParentDetails(true)
		// getParentDetailsReq(OnClick, currency)
		// setTransactionId(transactionId)
		// getWalletTransactionListReq()
		// getWalletTransactionListOnParentReq(parentid);
		getWalletTransactionListOnParentReq(parentid);

		// setTransactionId('')

		// let filteredParent = [].concat(getWalletTransactionListArray).filter((el) => el.transactionId == parentid)[0]
		// setParentDetailsArr({ ...filteredParent })
		// setparentIdModal(true)

	};


	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		getTransactionSubTypeListReqApi();
	// 	}
	// }, [regenerateTokenRes.data.status]);



	// const getCountryCodeFunc = (details, sel) => {
	// 	let res = details.filter(ch => ch.mobile === sel)
	// 	if (res.length == 0) {
	// 		return '';
	// 	} else {
	// 		return res[0].countryCode;
	// 	}
	// }
	// const getParentDetailsReq = (getparentId, currency) => {
	// 	const getTransactionTypeListReqIs = {

	// 		// loginDetails: {
	// 		// 	walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 		// },
	// 		walletTransactionMasterDetailsRequestVO: {
	// 			walletOwnerId: regenerateTokenRes.data.partnerId || "",
	// 			currency: currency,
	// 			fromDate: "",
	// 			toDate: "",
	// 			transactionId: getparentId,
	// 			isFee: "",
	// 			walletCustomerId: "",
	// 			transactionType: "",
	// 			transactionSubType: "",
	// 			toCustomerName: "",
	// 			toCustomerContact: "",
	// 			// toCustomerContact: getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0]) ? getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0]) + ' ' + customerOrMobName.split("-")[0] : customerOrMobName.split("-")[0],

	// 			status: "",
	// 			feeType: ""
	// 		}
	// 	};
	// 	console.log("gettttlissttt", customerOrMobName)
	// 	console.log("gettttlissttt", getTransactionTypeListReqIs)
	// 	// `+${row.fromContact.split(' ')[0]} `

	// 	// console.log("Fingerrrrr", deviceFingerPrint)
	// 	return dispatch(
	// 		// console.log("customercontactnnnnnnaa", getTransactionTypeListReqIs)
	// 		getWalletTransactionList(getTransactionTypeListReqIs, authToken)

	// 	);

	// }
	const handleFeeDetailsOpen = (transID, walletOID) => {
		setGetFeeDetailsOpenModal(true)
		getFeeDetailsListReq(transID, walletOID)

	}
	const getFeeDetailsListReq = (transID, walletOID) => {
		setGetFeeDetailsListStatus(true)
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: transID,
				transactionId: walletOID
			}
		}
		// console.log("REQQQ",req)
		return dispatch(
			getFeeDetailsByIds(req, authToken)
		);
	}


	// useEffect(() => {
	// if (partnerGetFeeDetailsByIDRes.data.status) {
	// 		partnerGetRefundDetailsFunc()
	// 	}

	// }, [partnerGetFeeDetailsByIDRes])

	// useEffect(() => {
	// 	if (getFeeDetailsListStatus) {
	// 		partnerGetFeeDetailsListFunc();
	// 	}
	// }, [partnerGetFeeDetailsByIDRes]);
	useEffect(() => {
		partnerGetFeeDetailsListFunc();
	}, [partnerGetFeeDetailsByIDRes]);

	// useEffect(() => {
	// 	console.log("partnerGetRefundDetailsRestttt", partnerGetRefundDetailsRes);

	// 	if (partnerGetFeeDetailsByIDRes.data.status) {
	// 		partnerGetFeeDetailsListFunc()
	// 	}
	//console.log("FEEDETAILS",partnerGetFeeDetailsByIDRes)

	// }, [partnerGetFeeDetailsByIDRes])
	const partnerGetFeeDetailsListFunc = () => {
		if (partnerGetFeeDetailsByIDRes && partnerGetFeeDetailsByIDRes.data) {
			if (partnerGetFeeDetailsByIDRes.data.status === "success") {
				setFeeDetailsModal(true);
				setFeeDetailsArr([].concat(partnerGetFeeDetailsByIDRes.data.Response));
			} else if (
				partnerGetFeeDetailsByIDRes.data.status === "failed" ||
				partnerGetFeeDetailsByIDRes.data.status === "Failed"
			) {
				setFeeDetailsModal(false);

				if (partnerGetFeeDetailsByIDRes.data.description === "session out") {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				} else if (
					partnerGetFeeDetailsByIDRes.data.description === "Authorization failed"
				) {
					// safeRegenerateToken();
				} else if (partnerGetFeeDetailsByIDRes.data.status === "Not found") {
					setCustomerOrMobName([]);
				}
			}
		} else {
			//console.log('partnerGetFeeDetailsByIDRes is undefined or missing data');
		}
	};

	// const partnerGetFeeDetailsListFunc = () => {
	// 	if (partnerGetFeeDetailsByIDRes.data.status == "success") {
	// 		// setGetRefundOpenModal(true);
	// 		setFeeDetailsModal(true)
	// 		setFeeDetailsArr([].concat(partnerGetFeeDetailsByIDRes.data.Response))
	// 	}
	// 	if (partnerGetFeeDetailsByIDRes.data.status == "failed" || partnerGetFeeDetailsByIDRes.data.status == "Failed") {
	// 		//   setCustomerOrMobName(partnerGetRefundDetailsRes.data);
	// 		// setGetRefundOpenModal(true);
	// 		setFeeDetailsModal(false)

	// 		if (
	// 			partnerGetFeeDetailsByIDRes.data.description == "session out"
	// 		) {
	// 			SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 		}
	// 		if (
	// 			partnerGetFeeDetailsByIDRes.data.description ==
	// 			"Authorization failed"
	// 		) {
	// 			regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
	// 		}
	// 		if (partnerGetFeeDetailsByIDRes.data.status === "Not found") {
	// 			setCustomerOrMobName([]);
	// 		}
	// 	}
	// };

	// useEffect(() => {
	// 	console.log("partnerGetFeeDetailsByIDRes", partnerGetFeeDetailsByIDRes);
	// 	if (partnerGetFeeDetailsByIDRes.data.status) {
	// 		partnerGetFeeDetailsListFunc()

	// 	}

	// }, [partnerGetFeeDetailsByIDRes]);


	//console.log(customerId, "customerId")
	const getWalletTransactionListReq = () => {
		// console.log("TRanssssIIIIDDDDD", getparentId)
		if (!selectedDate || !selectedToDate) {
			alert("Please enter a Date..!!");
			return; // Stop the execution if "From Date" is not selected
		}
		setIsLoading(true);
		setGetWalletTransactionListStatus(true);
		setSearchLoading(true);  // ← start button spinner

		const getTransactionTypeListReqIs = {
			// loginDetails: {
			// 	walletOwnerId: regenerateTokenRes.data.partnerId || ""
			// },
			walletTransactionMasterDetailsRequestVO: {
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				currency: currency,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: transactionId,
				isFee: isFee === "All" ? "" : isFee,
				walletCustomerId: customerId.split("-")[0] || "",
				transactionType: transactionType,
				transactionSubType: getTransactionsSubType,
				toCustomerName: toCustName.trim(),
				toCustomerContact: customerOrMobName.split("-")[0].substring(1),
				// toCustomerContact: getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0]) ? getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0]) + ' ' + customerOrMobName.split("-")[0] : customerOrMobName.split("-")[0],
				status: transStatus === "All" ? "" : transStatus,
				feeType: getFeeType === "All" ? "" : getFeeType,
				pageNo: (pageNumberOne() && hasFilters() && isSearchClick)
					? 1
					: pageNo + 1,
				records: rowsPerPage,
				orderDescription: invoiceid,
				studentId: studentId,
				paymentReference: paymentReference,
				timestamp: timestamp,
				parentId: parentId,

			}
		};

		return dispatch(
			getWalletTransactionList(getTransactionTypeListReqIs, authToken)
		);
	};




	// IF ANY ONE ENTITY FOUND THEN PAGE NUMBER 1 GOING TO getWalletTransactionListReq THIS REQUEST  
	function pageNumberOne() {

		if (transactionId || toCustName || customerOrMobName || getFeeType || transactionType || getTransactionsSubType || transStatus || invoiceid) {
			return 1
		} else {
			return 0
		}

	}

	const hasFilters = () => {
		return (
			transactionId !== "" ||
			transStatus !== "" ||
			transactionType !== "" ||
			customerId !== "" ||
			currency !== "" ||
			isFee !== "" ||
			paymentReference !== "" ||
			studentId !== "" ||
			invoiceid !== "" ||
			timestamp !== "" ||
			parentId !== ""
		);
	};



	// useEffect((arr) => {
	// 	let z = arr.filter(x => { return (x.mobile) })
	// 	console.log("zzzListttt", z)
	// }, [customerOrMobName])

	useEffect(() => {
		if (currency) {
			getWalletTransactionListReq();
		}

	}, [pageNo, rowsPerPage])

	useEffect(() => {
		if (getWalletTransactionListStatus) {
			getWalletTransactionListFun();
		}
	}, [getWalletTransactionListRes.data.status]);

	const getWalletTransactionListFun = () => {
		if (getWalletTransactionListRes.data.status === "success") {
			//console.log("DATAAAA", getWalletTransactionListRes.data)
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner
			setGetWalletTransactionListArray(
				[].concat(getWalletTransactionListRes.data.transactionList)
			);
			// setPageNo(getWalletTransactionListRes.data.pageNo)
		}
		if (getWalletTransactionListRes.data.status == "failed") {
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			NotificationPopups(
				"error",
				"Failed",
				getWalletTransactionListRes.data.description
			);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			// if (
			// 	getWalletTransactionListRes.data.description == "Authorization failed"
			// ) {
			// 	safeRegenerateToken();
			// }
		}

		if (getWalletTransactionListRes.data.status == "Failed") {
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
			NotificationPopups(
				"error",
				"Failed",
				getWalletTransactionListRes.data.description
			);
			if (
				getWalletTransactionListRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListRes.data.description == "Authorization failed"
			) {
				// safeRegenerateToken();
			}
		}

		if (getWalletTransactionListRes.data.status == "NOT FOUND") {
			setIsLoading(false);
			setSearchLoading(false);  // ← stop button spinner
			setGetWalletTransactionListArray(getWalletTransactionListRes.data);
		}
	};


	useEffect(() => {

		return () => {
			dispatch(resetGetWalletTransactionListOnParent())
			setparentIdModal(false)

		}
	}, []);





	const getWalletTransactionListOnParentFun = () => {

		if (getWalletTransactionListOnParentRes.data.status == "success") {
			// setGetWalletTransactionListArray(
			//   [].concat(getWalletTransactionListRes.data.transactionList)
			// );
			setIsLoading(false);
			setparentIdModal(true)
			setParentDetailsArr([].concat(getWalletTransactionListOnParentRes.data.transactionList)[0])
			// setIsLoading(false);
			// setDownloadBtn(false);
		}
		if (getWalletTransactionListOnParentRes.data.status == "failed") {
			// setGetWalletTransactionListArray(getWalletTransactionListOnParentRes.data);
			// setIsLoading(false);
			// setDownloadBtn(true);
			NotificationPopups(
				"error",
				"Failed",
				getWalletTransactionListOnParentRes.data.description ||
				getWalletTransactionListOnParentRes.description
			);
			if (getWalletTransactionListOnParentRes.data.description == "session out") {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListOnParentRes.data.description == "Authorization failed"
			) {
				NotificationPopups("error", "Failed", "Please try again.");
				// regenerateToken(
				// 	dispatch,
				// 	authToken,
				// 	regenerateTokenRes.data.partnerId
				// );
			}
		}

		if (getWalletTransactionListOnParentRes.data.status == "Failed") {
			// setGetWalletTransactionListArray(getWalletTransactionListOnParentRes.data);
			setIsLoading(false);
			//   setDownloadBtn(true);
			NotificationPopups(
				"error",
				"Failed",
				getWalletTransactionListOnParentRes.data.description ||
				getWalletTransactionListOnParentRes.description
			);
			if (getWalletTransactionListOnParentRes.data.description == "session out") {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				getWalletTransactionListOnParentRes.data.description == "Authorization failed"
			) {
				NotificationPopups("error", "Failed", "Please try again.");
				// regenerateToken(
				// 	dispatch,
				// 	authToken,
				// 	regenerateTokenRes.data.partnerId
				// );
			}
		}

		if (getWalletTransactionListOnParentRes.data.status == "NOT FOUND") {
			// setGetWalletTransactionListArray(getWalletTransactionListOnParentRes.data);
			setIsLoading(false);
			//   setDownloadBtn(true);
			NotificationPopups(
				"error",
				"NOT FOUND",
				getWalletTransactionListOnParentRes.data.status
			);
		}

	};


	useEffect(() => {
		//("getWalletTransactionListOnParentRes", getWalletTransactionListOnParentRes);
		if (getWalletTransactionListOnParentRes.data.status) {
			getWalletTransactionListOnParentFun()
			// getWalletTransactionListFun()
		}

	}, [getWalletTransactionListOnParentRes]);






	const csv = "1";
	const pdf = "0";

	// ✅ Prevent double click with loading guard
	// const handleDownloadClick = (csvOrPdf) => {
	//   if (generateWalletTransactionReportFileRes.isLoading) return; // ✅ block double call
	//   getTransactionReportFileExcelOrPdf(csvOrPdf);
	// };
	const handleDownloadClick = (csvOrPdf) => {
		if (generateRes.isLoading) return;
		getTransactionReportFileExcelOrPdf(csvOrPdf);
	};

	const getTransactionReportFileExcelOrPdf = (csvOrPdf) => {
		const fileType = csvOrPdf === "1" ? "csv" : "pdf";

		const requestObj = {
			loginDetails: {
				walletOwnerId:
					login.data.subRole === ""
						? login.data.partnerId
						: login.data.parentId,
			},
			walletTransactionMasterDetailsRequestVO: {
				currency: currency,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: transactionId,
				isFee: isFee,
				walletCustomerId: customerId.split("-")[0],
				reportFileType: fileType,
				pageNo: 1,
				records: rowsPerPage,
				status: transStatus === "All" ? "" : transStatus,
				isFee: isFee === "All" ? "" : isFee,
				transactionType: transactionType,
				transactionSubType: getTransactionsSubType,
				toCustomerContact: customerOrMobName.split("-")[0].substring(1),
				feeType: getFeeType === "All" ? "" : getFeeType,
				orderDescription: invoiceid,
				studentId: studentId,
				paymentReference: paymentReference,
				timestamp: timestamp,
				parentId: parentId,


			},
		};

		dispatch(
			generateWalletTransactionReportFileReq(
				requestObj,
				authToken,
				fileType
			)
		);
	};
	useEffect(() => {
		if (!generateRes.success) return;

		const blob = generateRes.data?.blob;
		if (!blob) return;

		console.log("✅ Downloading file:", blob);

		const url = window.URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;

		// 🔥 detect type
		let extension = "csv";

		if (blob.type.includes("zip")) extension = "zip";
		else if (blob.type.includes("pdf")) extension = "pdf";

		link.download = `TransactionReport.${extension}`;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		window.URL.revokeObjectURL(url);

		dispatch(resetGenerateWalletTransactionReportFile());

	}, [generateRes]);
	// const getTransactionReportFileExcelOrPdf = (csvOrPdf) => {
	// 	setGetTransactionReportFileRes(true);
	// 	const getTransactionReportListObj = {
	// 		loginDetails: {
	// 			walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
	// 		},
	// 		walletTransactionMasterDetailsRequestVO: {
	// 			currency: currency,
	// 			fromDate: moment(selectedDate).format("DD/MM/YYYY"),
	// 			toDate: moment(selectedToDate).format("DD/MM/YYYY"),
	// 			transactionId: transactionId,
	// 			isFee: isFee,
	// 			walletCustomerId: customerId.split("-")[0],
	// 			reportFileType: csvOrPdf == "1" ? "csv" : "pdf",
	// 			pageNo: pageNumberOne() ? 1 : pageNo + 1,
	// 			records: rowsPerPage
	// 		}
	// 	};

	// 	return dispatch(
	// 		generateWalletTransactionReportFileReq(
	// 			getTransactionReportListObj,
	// 			authToken
	// 		)
	// 	);
	// };

	// useEffect(() => {
	// 	if (getTransactionReportFileResStatus) {
	// 		if (generateWalletTransactionReportFileRes.data.status == "success") {
	// 			var link = document.createElement("a");
	// 			link.download = generateWalletTransactionReportFileRes.data.fileName;
	// 			link.href =
	// 				"data:application/octet-stream;base64," +
	// 				generateWalletTransactionReportFileRes.data.fileDate.split(`,`)[1];
	// 			link.click();
	// 		}
	// 	}
	// }, [generateWalletTransactionReportFileRes.data.status]);

	// useEffect(() => {
	// 	if (getTransactionReportFileResStatus) {
	// 		if (generateWalletTransactionReportFileRes.data.status == "success") {
	// 			var link = document.createElement("a");
	// 			link.target = "_blank";

	// 			// ✅ NEW - use filePath directly as URL
	// 			link.href = generateWalletTransactionReportFileRes.data.filePath;
	// 			link.download = generateWalletTransactionReportFileRes.data.filePath.split("/").pop(); // extracts filename from URL

	// 			link.click();
	// 		}
	// 	}
	// }, [generateWalletTransactionReportFileRes.data.status]);



	// useEffect(() => {
	// 	if (getTransactionReportFileResStatus) {
	// 		if (generateWalletTransactionReportFileRes.data.status == "success") {

	// 			// ✅ Create link, append to body, click, then remove safely
	// 			const link = document.createElement("a");
	// 			link.href = generateWalletTransactionReportFileRes.data.filePath;
	// 			link.download = generateWalletTransactionReportFileRes.data.filePath.split("/").pop();
	// 			link.target = "_blank";

	// 			document.body.appendChild(link); // ✅ append to body first
	// 			link.click();
	// 			document.body.removeChild(link); // ✅ remove from same parent
	// 		}
	// 	}
	// }, [generateWalletTransactionReportFileRes.data.status]);

	useEffect(() => {
		if (getWalletTransactionListRes.data.status == "success" && transactionId > 0) {
			setPageNo(0);
		}
	}, [getWalletTransactionListRes.data.status]);


	// const filterOptions = createFilterOptions({
	// 	matchFrom: "any",
	// 	limit: 15
	// });

	//console.log(getCustomerIdAndNameListRes, "getCustomerIdAndNameListRes")
	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		const getCustomerIdAndNameReq = {
	// 			loginDetails: {
	// 				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
	// 			},
	// 			actionCustomerMasterRequestVO: {
	// 				customerNameOrId: ""
	// 			}
	// 		};

	// 		dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
	// 	}
	// }, [regenerateTokenRes.data.status]);


	useEffect(() => {
		setGetRefundOpenModal(false);

		dispatch(resetPartnerGetRefundDetails())
		return () => {
			setGetRefundOpenModal(false);

			dispatch(resetPartnerGetRefundDetails())
		}
	}, [])
	// useEffect(() => {


	// 	dispatch(resetAdminCurrencyList())
	// 	return () => {


	// 		dispatch(resetAdminCurrencyList())
	// 	}
	// }, [])
	// useEffect(() => {


	// 	dispatch(resetGetWalletTransactionList())
	// 	return () => {


	// 		dispatch(resetGetWalletTransactionList())
	// 	}
	// }, [])

	useEffect(() => {
		if (getUsernameContactSuggestionRes.data.status === "success") {
			//console.log("lissttt", getUsernameContactSuggestionRes.data.list)
		}
	}, [getUsernameContactSuggestionRes.data.status])

	useEffect(() => {
		if (getUsernameSuggestionRes.data.status === "success") {
			//console.log("lissttt", getUsernameSuggestionRes.data.list)
		}
	}, [getUsernameSuggestionRes.data.status])


	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		const getUserContactReq = {
	// 			actionCustomerMasterRequestVO: {
	// 				customerMobileOrName: customerOrMobName,
	// 				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
	// 			}
	// 		}
	// 		dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
	// 		// console.log("userContact", getUserContactReq)
	// 	}
	// }, [regenerateTokenRes.data.status])

	//Customer/Beneficiery name
	const filterOptionsN = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptionsNames = options.filter(
			(option) =>

				option &&
				option.customerMobileOrName &&
				option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptionsNames.slice(0, 20);
	}


	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				(option.mobile && option.mobile.includes(inputValue)) ||
				(option.customerMobileOrName && option.customerMobileOrName.includes(inputValue))  // ← guard added
		);

		return filteredOptions.slice(0, 20);
	}

	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	const invoiceLabelS = (
		val.walletOwnerId === "199" ||
		val.walletOwnerId === "201" ||
		val.walletOwnerId === "200"
	) ? "Order Reference" : "Order Reference";


	const rawHistoryList = viewTransactionDetailsResArray?.transactionHistoryVOList;
	const historyList = Array.isArray(rawHistoryList)
		? rawHistoryList
		: rawHistoryList
			? [rawHistoryList]
			: [];

	const invoiceList = React.useMemo(() => {
		try {
			return JSON.parse(
				viewTransactionDetailsResArray?.invoiceDetails || "[]"
			);
		} catch (e) {
			return [];
		}
	}, [viewTransactionDetailsResArray]);

	// ✅ REPLACE with ONE consolidated useEffect:
	useEffect(() => {
		if (regenerateTokenRes.data.status !== "success") return;
		if (hasInitialized.current) return; // prevent re-running on every token refresh

		hasInitialized.current = true;

		// 1. Currency list
		getTransactionCurrencyListFunc();

		// 2. Transaction type list
		getTransactionTypeListReqApi();

		// 3. Customer ID list
		const getCustomerIdAndNameReq = {
			loginDetails: {
				walletOwnerId: login.data.subRole === ""
					? login.data.partnerId
					: login.data.parentId,
			},
			actionCustomerMasterRequestVO: { customerNameOrId: "" }
		};
		dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));

		// 4. User contact suggestion list
		const getUserContactReq = {
			actionCustomerMasterRequestVO: {
				customerMobileOrName: "",
				walletOwnerId: login.data.subRole === ""
					? login.data.partnerId
					: login.data.parentId,
			}
		};
		dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken));

	}, [regenerateTokenRes.data.status]);





	return (
		<>
			<>
				<Layout>
					<Card>
						{/* <BackButton /> */}
						<Grid
							container
							spacing={2}
							style={{ padding: "25px", marginTop: "2rem" }}
						>
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="From Date"
											format="MM/dd/yyyy"
											value={selectedDate}
											onChange={handleDateChange}
											disableFuture={true}

										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<FormControl fullWidth>
									<LocalizationProvider dateAdapter={AdapterDateFns}>
										<DatePicker
											label="To Date"
											format="MM/dd/yyyy"
											value={selectedToDate}
											onChange={handleToDateChange}
											disableFuture={true}
											minDate={selectedDate}

										/>
									</LocalizationProvider>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="timestamp"
									label="Time Stamp"
									type="name"
									fullWidth
									name="timestamp"

									// value={timestamp || ""}
									defaultValue={"All" || timestamp}
									onChange={handleChange}
									variant="standard"

								>
									<MenuItem value="All" selected="All	">
										Select Time Stamp
									</MenuItem>
									{/* <MenuItem value="Select Timestamp">
										select Time Stamp
									</MenuItem> */}
									<MenuItem value="CreationTime">CreationTime</MenuItem>
									<MenuItem value="SuccessTime" >SuccessTime</MenuItem>
									<MenuItem value="UpdationTime" >UpdateTime</MenuItem>

								</TextField>
							</Grid>

							{/* <Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									required
									margin="dense"
									id="name"
									label="Customer Id"
									type="text"
									fullWidth
									value={customerId || ""}
									name="customerId"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
								/>
							</Grid> */}

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Transaction Status"
									type="tel"
									fullWidth
									style={{ marginTop: "3px" }}
									name="transStatus"
									onChange={handleChange}
									defaultValue={"All" || transStatus}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Success">Success</MenuItem>
									<MenuItem value="Failed">Failed</MenuItem>
									<MenuItem value="Pending">Pending</MenuItem>
									<MenuItem value="Processing">Processing</MenuItem>
									<MenuItem value="Cancelled">Cancelled</MenuItem>
									<MenuItem value="Declined">Declined</MenuItem>
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={customerId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setCustomerId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Customer/Merchant ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}
											// InputProps={{
											// 	sx: {
											// 	  "&:before": { borderBottomColor: "gray" }, // before focus
											// 	  "&:after": { borderBottomColor: "gray" },  // after focus
											// 	},
											//   }}
											//   InputLabelProps={{
											// 	sx: { color: 'gray' }, // Optional: if you want the label to be white
											//   }}
											sx={{
												"& .MuiInput-underline:before": {
													borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
													borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
													borderBottomColor: "gray", // White color after focus
												},
											}}
											name="customerId"

											variant="standard"
										/>
									)}
								/>
							</Grid>



							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Transaction Id"
									type="tel"
									fullWidth
									value={transactionId}
									name="transactionId"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								/>
							</Grid>



							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Transaction Type"
									type="tel"
									fullWidth
									// value={transactionType}
									value={transactionType || ""}
									name="transactionType"
									onChange={handleChange}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								>
									<MenuItem
										value="Select Transaction Type"
										selected="Select Transaction Type"
									>
										Select Transaction Type
									</MenuItem>
									{(() => {
										if (getTransactionTypeListResArray) {
											return getTransactionTypeListResArray.map((c) => (
												<MenuItem value={c} key={c}>
													{/* {c === "LOAD" ? "Fund Top Up": c} */}
													{/* {c === "PURCHASE" ? "Purchase" */}
													{c === "PURCHASE" || c === "Purchase" ? "Transaction"

														: c === "LOAD" ? "Fund Top-up"
															: c === "RECEIVED" ? "Fund Received"
																: c === "SEND" ? "Fund Transfer"

																	: c === "WITHDRAW" ? "Withdraw"
																		: c === "BANK TRANSFER" ? "Bank Transfer"
																			: c}

												</MenuItem>
											));
										} else {
											return <MenuItem>No Data</MenuItem>;
										}
									})()}
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Transaction SubType"
									type="tel"
									fullWidth
									// value={transactionType}
									value={getTransactionsSubType || ""}
									name="getTransactionsSubType"
									onChange={handleChange}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								>
									<MenuItem
										value="Select Transaction SubType"
										selected="Select Transaction SubType"
									>
										Select SubType
									</MenuItem>
									{(() => {
										if (getTransactionSubTypeListResArray) {
											return [].concat(getTransactionSubTypeListResArray).map((c) => (
												<MenuItem value={c} key={c}>
													{/* {c} */}
													{usesTransactionSubTypes(transactionType) &&
														(c === "WALLET" || c === "Wallet")
														? "APM"
														: c}
												</MenuItem>
											));
										} else {
											return <MenuItem>No Data</MenuItem>;
										}
									})()}
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Currency"
									type="name"
									fullWidth
									name="currency"
									value={currency || ""}
									onChange={handleChange}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" },
											"&:after": { borderBottomColor: "gray" },
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' },
									}}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>

									{/* ✅ Replace adminCurrencyList with getTransactionCurrencyListRes */}
									{getTransactionCurrencyListRes?.success &&
										getTransactionCurrencyListRes?.data?.status === "success" &&
										[]
											.concat(getTransactionCurrencyListRes.data.currencyList || [])
											.map((x) => (
												<MenuItem value={x} key={x}>{x}</MenuItem>
											))
									}
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Student Id"
									type="tel"
									fullWidth
									value={studentId}
									name="studentId"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								/>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Show Fee Transactions"
									type="name"
									fullWidth
									name="isFee"
									// value={isFee || ""}
									defaultValue={"All" || isFee}
									onChange={handleChange}
									variant="standard"

								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Y">Yes</MenuItem>
									<MenuItem value="N">No</MenuItem>
								</TextField>
							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Parent Id"
									type="tel"
									fullWidth
									value={parentId}
									name="parentId"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								/>
							</Grid>

							{/* <Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Show Fee Transactions"
									type="name"
									fullWidth
									name="isFee"
									// value={isFee || ""}
									defaultValue={"All" || isFee}
									onChange={handleChange}
									variant="standard"

								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Y">Yes</MenuItem>
									<MenuItem value="N">No</MenuItem>
								</TextField>
							</Grid> */}
							{/* <Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									select
									autoFocus
									disabled={isFee === "N" ? true : false}
									margin="dense"
									id="name"
									label="Select Fee Type"
									type="name"
									fullWidth
									name="getFeeType"
									style={{ marginTop: "3px" }}

									// value={isFee || ""}
									defaultValue={"All" || getFeeType}
									onChange={handleChange}
									variant="standard"

								>
									<MenuItem value="All" selected="All">
										All
									</MenuItem>
									<MenuItem value="Fee Paid">Fee Paid</MenuItem>
									<MenuItem value="Fee Received">Fee Received</MenuItem>
								</TextField>
							</Grid> */}
							<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getUsernameSuggestionRes.data.list || [""]
									)}
									getOptionLabel={(option) => option.customerMobileOrName}
									filterOptions={filterOptionsN}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Name"
											style={{ marginTop: "3px" }}
											type="text"
											fullWidth
											{...params}
											value={toCustName || ""}
											name="toCustName"
											onBlur={handleChange}
											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
													borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
													borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
													borderBottomColor: "gray", // White color after focus
												},
											}}
										/>
									)}
								/>
								{/* <TextField
									autoFocus
									margin="dense"
									id="name"
									label="Beneficiary Name"
									type="tel"
									fullWidth
									value={toCustName}
									name="toCustName"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
								/> */}

							</Grid>

							<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getUsernameContactSuggestionRes.data.list || [""]
									)}
									getOptionLabel={(option) => "+" + option.countryCode + " " + option.mobile + "-" + option.customerMobileOrName}
									filterOptions={filterOptions}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Contact"
											style={{ marginTop: "3px" }}
											type="text"
											fullWidth
											{...params}
											value={customerOrMobName || ""}
											name="customerOrMobName"
											onBlur={handleChange}
											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
													borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
													borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
													borderBottomColor: "gray", // White color after focus
												},
											}}
										/>
									)}
								/>
							</Grid>


							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									// label="Invoice Id"
									label={invoiceLabelS}
									type="tel"
									fullWidth
									value={invoiceid}
									name="invoiceid"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								/>
							</Grid>



							<Grid item xs={12} sm={12} md={3} lg={3}>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Payment Reference"
									type="tel"
									fullWidth
									value={paymentReference}
									name="paymentreference"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
									variant="standard"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}

								/>
							</Grid>

							








							<Grid item xs={12} sm={12} md={3} lg={3}>
								{/* <CustomButton
									// className="buttonSearch"
									style={{
										padding: "8px"
									}}
									onClick={() => {
										setIsSearchClick(true);
										setPageNo(0); // reset page
										getWalletTransactionListReq()
									}}
								>
									Searchs <SearchIcon />
								</CustomButton> */}
								<CustomButton
									style={{ padding: "8px" }}
									onClick={() => {
										setIsSearchClick(true);
										setPageNo(0); // reset page
										getWalletTransactionListReq()
									}}
									disabled={searchLoading}  // ← prevent double click
								>
									{searchLoading ? (
										<>
											Searching...&nbsp;
											<span
												className="spinner-border spinner-border-sm"
												role="status"
												aria-hidden="true"
											/>
										</>
									) : (
										<>
											Search <SearchIcon />
										</>
									)}
								</CustomButton>
							</Grid>
						</Grid>
					</Card>
					{isLoading ? (
						<LoadingSpinner />
					) : getWalletTransactionListArray.length == undefined ||
						!getWalletTransactionListStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Transactions List
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert
										className="my-3 tableHeaderColor"
										variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
									>
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						// <div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px",
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Transactions List
									</Typography>
								</Grid>
								<Grid
									container
									style={{
										padding: "10px",
										textAlign: "center",
										justifyContent: "right"
									}}
								>
									<Grid item xs={4} sm={4} md={1} lg={1}>
										<img
											src={`${process.env.PUBLIC_URL}/${Theme}/excel.png`}
											alt="m-transact"
											style={{
												height: "30px",
												cursor: generateRes.isLoading
													? "not-allowed"   // ✅ show disabled cursor while loading
													: "pointer",
												opacity: generateRes.isLoading ? 0.5 : 1,
											}}
											onClick={() => handleDownloadClick(csv)} // ✅ guarded click

										// style={{ height: "30px", cursor: "pointer" }}
										// onClick={() => {
										// 	getTransactionReportFileExcelOrPdf(csv);
										// }}
										/>
									</Grid>
									{/* <Grid item xs={4} sm={4} md={1} lg={1}>
										<img
											src={`${process.env.PUBLIC_URL}/${Theme}/pdf1.png`}
											alt="m-transact"

											style={{ height: "30px", cursor: "pointer" }}
											onClick={() => {
												getTransactionReportFileExcelOrPdf(pdf);
											}}
										/>
									</Grid> */}
								</Grid>
								<TableContainer component={Paper} className="my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction Date
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction Id
												</TableCell>


												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Order Reference
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction Type
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Transaction SubType
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Beneficiary Name
												</TableCell>


												{/* <TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Is Fee
												</TableCell> */}
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Transaction Amount
												</TableCell>


												{showAction && (<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>)}
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Details
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{getWalletTransactionListArray &&
												[]
													.concat(getWalletTransactionListArray)
													// .slice(
													// 	pageNo * rowsPerPage,
													// 	pageNo * rowsPerPage + rowsPerPage
													// )
													.map((row, index) => (
														<>
															<TableRow key={index}>
																{/* <TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.status}
																</TableCell> */}
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.status === "Success" && (
																		<Tooltip title="Success">
																			<span><FaCheckCircle style={{ color: '#3fc908' }} size={20} /></span>
																		</Tooltip>
																	)}
																	{row.status === "Failed" && (
																		<Tooltip title="Failed">
																			<span><MdCancel style={{ color: 'red' }} size={20} /></span>
																		</Tooltip>
																	)}
																	{row.status === "Pending" && (
																		<Tooltip title="Pending">
																			<span><FaClock style={{ color: 'grey' }} size={20} /></span>
																		</Tooltip>
																	)}
																	{row.status === "Processing" && (
																		<Tooltip title="Processing">
																			<span><ImSpinner11 style={{ color: '#ddcf05ff' }} size={20} /></span>
																		</Tooltip>
																	)}
																	{row.status === "Cancelled" && (
																		<Tooltip title="Cancelled">
																			<span><TiCancel style={{ color: '#dd0505ff' }} size={25} /></span>
																		</Tooltip>
																	)}
																	{row.status === "Declined" && (
																		<Tooltip title="Declined">
																			<span><TiCancel style={{ color: '#000000ff' }} size={20} /></span>
																		</Tooltip>
																	)}
																	{/* Fallback for any other status or if status is empty/null */}
																	{!row.status || row.status === "" || (!["Success", "Failed", "Pending", "Processing", "Cancelled", "Declined"].includes(row.status)) ? "-" : null}
																</TableCell>
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.updateTime}
																</TableCell>
																{/* <TableCell style={{ borderBottom: "0" }}> */}
																{/* <IconButton
																		aria-label="expand row"
																		size="small"
																		onClick={() => {
																			onButtonClick(row.transactionId);
																			if (row.isRefundDisplay === "Y") {
																				getRefundDetailsPartnerReq(row.walletOwnerId, row.transactionId)

																			}
																		}}
																	>
																		{open == row.transactionId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																	</IconButton> */}
																{/* <IconButton
																		aria-label="expand row"
																		size="small"
																		onClick={() => {
																			onButtonClick(row.transactionId, row.currency);
																			if (row.isRefundDisplay === "Y") {
																				getRefundDetailsPartnerReq(row.walletOwnerId, row.transactionId)

																			}
																		}
																		}
																	>
																		{open === row.transactionId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																	</IconButton>
																</TableCell> */}
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.transactionId}
																</TableCell>
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.orderDescription}
																</TableCell>
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{getTransactionTypeLabel(row.transactionType)}
																</TableCell>
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{getTransactionSubTypeLabel(row.transactionSubType)}
																</TableCell>
																{/* <TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.transactionType}
																</TableCell>
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{row.transactionSubType}
																</TableCell> */}
																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{!row.toCustName || row.toCustName == ""
																		? "-"
																		: row.toCustName}
																</TableCell>


																<TableCell align="center" style={{ borderBottom: "0" }}>
																	{getSymbolFromCurrency(row.currency) +
																		" " +
																		row.amount}
																</TableCell>
																{/* <TableCell align="center" style={{ borderBottom: "0" }} className={
																	(row.creditAmount > 0 ? 'text-success' : row.debitAmount > 0 ? 'text-danger' : 'text-secondary') + ' font-weight-bold'
																}>
																	{getSymbolFromCurrency(row.currency) +
																		" " +
																		(
																			row.creditAmount > 0 ? row.creditAmount : row.debitAmount > 0 ? row.debitAmount : row.amount)
																	}
																</TableCell> */}
																{/* <TableCell align="center" style={{ borderBottom: "0" }}>
																	{
																		(row.transactionType === 'WITHDRAW' || row.transactionType === "LOAD") &&
																			(row.transactionSubType === 'Card Transfer' || row.transactionSubType === 'Card Transfer') ?


																			<div style={{ color: row.transactionType === 'WITHDRAW' ? "red" : "", fontWeight: "bold" }}>

																				{getSymbolFromCurrency(row.currency) +
																					" " + row.amount}</div>


																			:
																			row.debitAmount > 0.00 ? <div style={{ color: "red", fontWeight: "bold" }}>

																				{getSymbolFromCurrency(row.currency) +
																					" " + row.debitAmount}</div>

																				: row.creditAmount > 0.00 ? <div style={{ color: "green", fontWeight: "bold" }}>{
																					getSymbolFromCurrency(row.currency) +
																					" " +
																					row.creditAmount}</div>
																					:

																					getSymbolFromCurrency(row.currency) +
																					" " +
																					row.amount}

																</TableCell> */}
																{showAction && (
																	<TableCell align="center">
																		<Grid xs={12} sm={12} md={12} lg={12} style={{ display: "flex" }}>

																			<Tooltip title="Update">
																				<span>


																					<CustomButton
																						// disabled={(row.transactionStatus == "Pending" || row.transactionStatus == "Success") ? false : true}
																						disabled={!["Pending", "Processing"].includes(row.status) || row.isFee === "Yes"}
																						style={{
																							padding: "8px",
																							marginLeft: "10px"
																						}}


																						onClick={() =>
																							updateHandleClick(row.transactionId)
																						}


																					>

																						<EditIcon
																							style={{
																								color: "#fff",
																								fontSize: "20px"
																							}}
																						/>
																					</CustomButton>
																				</span>
																			</Tooltip>
																		</Grid>
																	</TableCell>
																)}
																<TableCell style={{ borderBottom: "0" }}>
																	{/* <IconButton
																		aria-label="expand row"
																		size="small"
																		onClick={() => {
																			onButtonClick(row.transactionId);
																			if (row.isRefundDisplay === "Y") {
																				getRefundDetailsPartnerReq(row.walletOwnerId, row.transactionId)

																			}
																		}}
																	>
																		{open == row.transactionId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																	</IconButton> */}
																	<IconButton
																		aria-label="expand row"
																		size="small"
																		onClick={() => {
																			onButtonClick(row.transactionId, row.currency);
																			if (row.isRefundDisplay === "Y") {
																				getRefundDetailsPartnerReq(row.walletOwnerId, row.transactionId)

																			}
																		}
																		}
																	>
																		{open === row.transactionId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																	</IconButton>
																</TableCell>
															</TableRow>
															<TableRow>
																<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
																	<Collapse
																		in={open == row.transactionId}

																		timeout="auto"
																		// onClick={() => onButtonClick(row.fromCustomerId
																		// )}
																		unmountOnExit
																	>
																		<Box margin={4}>
																			{partnerGetWalletTransactionListByIdRes.data
																				.transactionMasterDetailsResponseVO &&
																				partnerGetWalletTransactionListByIdRes.data
																					.transactionMasterDetailsResponseVO ? (
																				<>
																					{viewTransactionDetailsResArray && (
																						<Table
																							className={classes.table}
																							aria-label="a dense table"
																							style={{ whiteSpace: "nowrap" }}
																						>
																							<TableBody>
																								{viewTransactionDetailsResArray &&
																									[]
																										.concat(viewTransactionDetailsResArray)
																										.map((row, index) => (
																											<TableRow key={index}>
																												<Row>
																													<Col md={12}>
																														<Typography
																															variant="h6"
																															component="div"
																															className="mt-3"
																															style={{
																																fontSize: "1.4rem",
																															}}
																														>
																															Customer Info
																														</Typography>
																														<hr />
																														<Row>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>From Customer</Col>
																																	<Col md={6}>
																																		{" "}
																																		{!row.fromCustName || row.fromCustName == ""
																																			? "-"
																																			: row.fromCustName}
																																	</Col>
																																</Row>
																															</Col>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>From Customer Contact</Col>
																																	<Col md={5}>
																																		{row.fromContact === '-' ? '' :
																																			row.fromContact ?
																																				isMasked ?
																																					row.fromContact.split(' ').length == 1 ?
																																						'XX-XXXX-' + row.fromContact.substring(row.fromContact.length - 4) :
																																						`+${row.fromContact.split(' ')[0]} ` +
																																						'XX-XXXX-' +
																																						row.fromContact.split(' ')[1].substring(row.fromContact.split(' ')[1].length - 4) :
																																					row.fromContact.split(' ').length == 1 ?
																																						row.fromContact :
																																						`+${row.fromContact}`
																																				: '-'
																																		}
																																	</Col>
																																	<Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMasked(!isMasked)}> {isMasked ? <VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}
																																	</span> </Col>
																																</Row>


																															</Col>

																														</Row>
																														<hr />
																														<Row>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Beneficiary Name</Col>
																																	<Col md={6}>
																																		{row.statusDescription == "Top Up in Wallet" || !row.toCustName ? "-" : row.toCustName}
																																	</Col>
																																</Row>
																															</Col>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Beneficiary Contact</Col>
																																	<Col md={5}>
																																		{/* {row.statusDescription === "Top Up in Wallet" || !row.toCustomerContact ? "-" :row.toCustomerContact} */}

																																		{row.statusDescription === "Top Up in Wallet" || !row.toCustomerContact ? "-" :
																																			row.toCustomerContact === "-" ? '-' :
																																				row.toCustomerContact ?
																																					isMaskedToContact ?
																																						row.toCustomerContact.split(' ').length == 1 ?
																																							'XX-XXXX-' + row.toCustomerContact.substring(row.toCustomerContact.length - 4) :
																																							`+${row.toCustomerContact.split(' ')[0]} ` +
																																							'XX-XXXX-' +
																																							row.toCustomerContact.split(' ')[1].substring(row.toCustomerContact.split(' ')[1].length - 4) :
																																						row.toCustomerContact.split(' ').length == 1 ?
																																							row.toCustomerContact :
																																							`+${row.toCustomerContact}`
																																					: '-'
																																		}
																																	</Col>
																																	<Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMaskedToContact(!isMaskedToContact)}>
																																		{isMaskedToContact ?
																																			row.statusDescription === "Top Up in Wallet" || !row.toCustomerContact || row.toCustomerContact === "-" ? "" :


																																				<VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}

																																	</span> </Col>


																																	{/* {row.statusDescription == "Top Up in Wallet" || !row.toCustomerContact ? "-" :
																									<Col md={4}> {isMaskedToContact ? "xxxx-xxxx-" + row.toCustomerContact.substring(8, 12) : row.toCustomerContact}
																										<span onClick={() => setIsMaskedToContact(!isMaskedToContact)}> {isMaskedToContact ? <Visibility /> : <VisibilityOff />}</span>

																									</Col>




																								} */}


																																	{/* <Col md={4}> {isMasked ? "xxxx-xxxx-" + row.toCustomerContact.substring(8, 12) : row.toCustomerContact} </Col>
																								<Col md={2}><span onClick={() => setIsMasked(!isMasked)}> {isMasked ? <Visibility /> : <VisibilityOff />}</span></Col> */}


																																</Row>

																															</Col>

																														</Row>
																														<hr />

																														<Row>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Customer ID</Col>
																																	<Col md={6}>
																																		{" "}
																																		{!row.fromCustomerId || row.fromCustomerId == "" || row.fromCustomerId == "0"
																																			? "-"
																																			: row.fromCustomerId}
																																	</Col>
																																</Row>
																															</Col>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Beneficiary ID</Col>
																																	<Col md={6}>
																																		{" "}
																																		{!row.toCustomerId || row.toCustomerId == "" || row.toCustomerId == "0"
																																			? "-"
																																			: row.toCustomerId}
																																	</Col>
																																</Row>


																															</Col>

																														</Row>

																														{/* ===== STUDENT INFO ===== */}
																														{/* {(row.studentId || row.consumerName || row.consumerEmail ||
																															row.consumerPhone || row.consumerCountry || row.paymentReference) && (
																																<Row>
																																	<Col md={12}>
																																		<Typography
																																			variant="h6"
																																			component="div"
																																			className="mt-3"
																																			style={{ fontSize: "1.4rem" }}
																																		>
																																			Student Info
																																		</Typography>
																																		<hr />
																																		<Row>
																																			<Col md={6} className="detail-info row">
																																				<Row>
																																					<Col md={6}>Student ID</Col>
																																					<Col md={6}>{row.studentId || "-"}</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} className="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Name</Col>
																																					<Col md={6}>{row.consumerName || "-"}</Col>
																																				</Row>
																																			</Col>
																																		</Row>
																																		<hr />
																																		<Row>
																																			<Col md={6} className="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Email</Col>
																																					<Col md={6}>{row.consumerEmail || "-"}</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} className="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Phone</Col>
																																					<Col md={6}>
																																						{!row.consumerPhone || row.consumerPhone === ""
																																							? "-"
																																							: row.consumerPhone}
																																					</Col>
																																				</Row>
																																			</Col>
																																		</Row>
																																		<hr />
																																		<Row>
																																			<Col md={6} className="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Country</Col>
																																					<Col md={6}>{row.consumerCountry || "-"}</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} className="detail-info row">
																																				<Row>
																																					<Col md={6}>Payment Reference</Col>
																																					<Col md={6}>{row.paymentReference || "-"}</Col>
																																				</Row>
																																			</Col>
																																		</Row>
																																		<hr />
																																	</Col>
																																</Row>
																															)} */}


																														{/* {(row.studentId || row.consumerName || row.consumerEmail ||
																															row.consumerPhone || row.consumerCountry || row.paymentReference) && (
																																< Row >
																																	<Col md={12}>
																																		<Typography
																																			variant="h6"
																																			component="div"
																																			className="mt-3"
																																			style={{
																																				fontSize: "1.4rem",
																																			}}
																																		>
																																			Student Info
																																		</Typography>
																																		<hr />
																																		<Row>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Student ID</Col>
																																					<Col md={6}>{row.studentId || "-"}</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Name</Col>
																																					<Col md={6}>{row.consumerName || "-"}</Col>

																																				</Row>


																																			</Col>

																																		</Row>
																																		<hr />
																																		<Row>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Email</Col>
																																					<Col md={6}>{row.consumerEmail || "-"}</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Phone</Col>
																																					<Col md={6}>
																																						{!row.consumerPhone || row.consumerPhone === ""
																																							? "-"
																																							: row.consumerPhone}
																																					</Col>
																																				</Row>

																																			</Col>

																																		</Row>
																																		<hr />
																																		<Row>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Student Country</Col>
																																					<Col md={6}>{row.consumerCountry || "-"}</Col>
																																				</Row>
																																			</Col>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Payment Reference</Col>
																																					<Col md={6}>{row.paymentReference || "-"}</Col>
																																				</Row>
																																			</Col>

																																		</Row>
																																	</Col>
																																</Row>)} */}

																														{/* ===== INVOICE DETAILS ===== */}


																														{invoiceList.length > 0 && (
																															<Row>
																																<Col md={12}>
																																	<Typography
																																		variant="h6"
																																		component="div"
																																		className="mt-3"
																																		style={{ fontSize: "1.4rem" }}
																																	>
																																		Invoice Details
																																	</Typography>
																																	<hr />

																																	<TableContainer component={Paper} style={{ marginBottom: "16px", maxHeight: "250px", overflowY: "auto", overflowX: "auto" }}>
																																		<Table size="small">
																																			<TableHead>
																																				<TableRow>
																																					<TableCell align="center"><b>Ref</b></TableCell>
																																					<TableCell align="center"><b>Date</b></TableCell>
																																					<TableCell align="center"><b>Due Date</b></TableCell>
																																					<TableCell align="center"><b>Amount</b></TableCell>
																																					<TableCell align="center"><b>Balance</b></TableCell>
																																					<TableCell align="center"><b>Description</b></TableCell>
																																				</TableRow>
																																			</TableHead>

																																			<TableBody>
																																				{invoiceList.map((invoice, idx) => (
																																					<TableRow key={idx}>
																																						<TableCell align="center">{invoice.ref || "-"}</TableCell>
																																						<TableCell align="center">{invoice.date || "-"}</TableCell>
																																						<TableCell align="center">{invoice.due_date || "-"}</TableCell>
																																						<TableCell align="center">{invoice.original_amount || "-"}</TableCell>
																																						<TableCell align="center">{invoice.balance || "-"}</TableCell>
																																						<TableCell align="center">{invoice.description || "-"}</TableCell>
																																					</TableRow>
																																				))}
																																			</TableBody>
																																		</Table>
																																	</TableContainer>

																																	<hr />
																																</Col>
																															</Row>
																														)}





																														<Row>
																															<Col md={12}>
																																<Typography
																																	variant="h6"
																																	component="div"
																																	className="mt-3"
																																	style={{
																																		fontSize: "1.4rem",
																																		paddingTop: "3.5%",
																																		paddingBottom: "1.5%",
																																	}}
																																>
																																	Transaction Info
																																</Typography>
																																<hr />

																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>From Account ID</Col>
																																			<Col md={6}>
																																				{!row.fromWalletId || row.fromWalletId == "" || row.fromWalletId == "0"
																																					? "-"
																																					: row.fromWalletId + " " + `${getSymbolFromCurrency(row.currency)}`}
																																			</Col>
																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>To Account ID</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.toWalletId || row.toWalletId == "" || row.toWalletId == "0"
																																					? "-"
																																					: row.toWalletId}
																																			</Col>
																																		</Row>
																																	</Col>
																																</Row>

																																<hr />
																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Transaction Sub Type</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.transactionSubType || row.transactionSubType == ""
																																					? "-"
																																					: getTransactionSubTypeLabel(row.transactionSubType)}

																																				{/* {!row.transactionSubType || row.transactionSubType == ""
																																					? "-"
																																					: row.transactionSubType} */}
																																			</Col>
																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Parent ID</Col>
																																			<Col md={6}>
																																				<Typography
																																					style={{
																																						color: "blue",
																																						cursor: "pointer",
																																						fontWeight: "bold",
																																						color: "blue",
																																					}}
																																					onClick={() => {

																																						handleParentOpen(
																																							row.parentId
																																						);
																																					}}
																																				>
																																					{" "}
																																					{!row.parentId ||
																																						row.parentId == ""
																																						? "-"
																																						: row.parentId}
																																				</Typography>
																																			</Col>
																																		</Row>

																																	</Col>
																																</Row>
																																<hr />

																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Payment Brand</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.paymentBrand || row.paymentBrand == ""
																																					? "-"
																																					: row.paymentBrand}
																																			</Col>
																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Payment Mode</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.paymentMode || row.paymentMode == ""
																																					? "-"
																																					: getTransactionSubTypeLabel(row.paymentMode)}
																																				{/* {!row.paymentMode || row.paymentMode == ""
																																					? "-"
																																					: row.paymentMode} */}
																																			</Col>
																																		</Row>

																																	</Col>
																																</Row>

																																<hr />

																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Order Reference</Col>
																																			<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
																																				{" "}
																																				{!row.orderDescription || row.orderDescription == ""
																																					? "-"
																																					: row.orderDescription}
																																			</Col>
																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Transaction Amount</Col>
																																			<Col md={6}>
																																				{row.amount && Number(row.amount) !== 0
																																					? `${getSymbolFromCurrency(row.currency)} ${row.amount}`
																																					: "-"
																																				}
																																			</Col>
																																		</Row>
																																	</Col>
																																</Row>
																																<hr />
																																<Row>
																																	{/* <Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Order Description</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.orderDescription || row.orderDescription == ""
																																					? "-"
																																					: row.orderDescription}
																																			</Col>
																																		</Row>
																																	</Col> */}
																																	<Col md={6}>
																																		<Row>


																																			<Col md={6}>Status Description</Col>
																																			<Col md={6}>
																																				{" "}
																																				{/* {!row.statusDescription || row.statusDescription == ""
																																					? "-"
																																					: row.statusDescription} */}
																																				{!row.statusDescription || row.statusDescription == ""
																																					? "-"
																																					: getStatusDescriptionLabel(row.statusDescription)}
																																			</Col>

																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>

																																			<Col md={6} >Remark</Col>
																																			<Col
																																				md={6}
																																				style={{ wordBreak: "break-word", whiteSpace: "normal" }}
																																			>
																																				{!row.remark || row.remark === ""
																																					? "-"
																																					: getRemarkLabel(row.remark)}
																																			</Col>
																																		</Row>
																																	</Col>
																																</Row>
																																<hr />
																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Status</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.status || row.status == ""
																																					? "-"
																																					: row.status}
																																			</Col>
																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Bank ID</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.trackingId || row.trackingId == "" || row.trackingId == "0"
																																					? "-"
																																					: row.trackingId}
																																			</Col>
																																		</Row>

																																	</Col>

																																</Row>
																																<hr />

																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Order Description</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.comment || row.comment == ""
																																					? "-"
																																					: row.comment}
																																			</Col>
																																		</Row>
																																	</Col>
																																	{(row.feeType === 'No' || row.feeType === '') ? null : (

																																		<Col md={6} class="detail-info row">
																																			<Row>
																																				<Col md={6}>Fee Type</Col>
																																				<Col md={6}>
																																					{" "}
																																					{!row.feeType || row.feeType == ""
																																						? "-"
																																						: row.feeType}
																																				</Col>
																																			</Row>
																																		</Col>
																																	)}
																																</Row>


																																<hr />

																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Update Time</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.updateTime || row.updateTime == ""
																																					? "-"
																																					: row.updateTime}
																																			</Col>
																																		</Row>
																																	</Col>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Success Time</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.successTime || row.successTime == "" || row.successTime == "0"
																																					? "-"
																																					: row.successTime}
																																			</Col>
																																		</Row>

																																	</Col>

																																</Row>

																																<hr />

																																<Row>
																																	<Col md={6} class="detail-info row">
																																		<Row>
																																			<Col md={6}>Settlement Date</Col>
																																			<Col md={6}>
																																				{" "}
																																				{!row.settlementDate || row.settlementDate == ""
																																					? "-"
																																					: row.settlementDate}
																																			</Col>
																																		</Row>
																																	</Col>
																																</Row>





																																{row.isRefundDisplay === "N" || row.isRefundDisplay === "Y" ? <hr /> : ""}


																																{row.isRefundDisplay === "Y" && refundFlag ? (
																																	<Col
																																		md={6}
																																		class="detail-info row"
																																	>
																																		<Row>


																																			<Col md={6}>
																																				<Typography
																																					className="RefundDet"
																																					style={{
																																						color: "Blue",
																																						// margin: "0px",
																																						fontWeight: "bold",
																																						marginLeft: "-12px",
																																					}}
																																					// variant="contained"
																																					onClick={() => {
																																						setGetRefundOpenModal(true);;
																																					}}
																																				>
																																					Refund Details
																																				</Typography>
																																			</Col>

																																		</Row>
																																	</Col>
																																) : (
																																	""
																																)}





																																{/* <hr /> */}
																																{/* {partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Offline Bank Transfer" || partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Wallet" || partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Bank Transfer" && */}
																																{row?.convertedCurrency && row?.convertedAmount && (
																																	<Row>
																																		<Col md={6} class="detail-info row">
																																			<Row>
																																				<Col md={6}>Exchange Rate </Col>
																																				<Col md={6}>
																																					{" "}
																																					1 GBP = {
																																						!row.convertedRate || row.convertedRate == "" || row.convertedRate == "0.00" || row.convertedRate == "0" || row.convertedRate == "0.0" || row.convertedRate == "0.000" || row.convertedRate == "undefined"
																																							? "-"
																																							: `${row.convertedRate} ${row.convertedCurrency}`
																																					}
																																				</Col>
																																			</Row>
																																		</Col>
																																		<Col md={6} class="detail-info row">
																																			<Row>

																																				<Col md={6}>Converted Amount </Col>
																																				<Col md={6}>
																																					{" "}
																																					{
																																						!row.convertedAmount || row.convertedAmount == "" || row.convertedAmount == "0.00" || row.convertedAmount == "0" || row.convertedAmount == "0.0" || row.convertedAmount == "0.000" || row.convertedAmount == "undefined"
																																							? "-"
																																							: `${row.convertedAmount} ${row.convertedCurrency}`
																																					}
																																				</Col>
																																			</Row>
																																		</Col>
																																	</Row>)}
																																{/* } */}

																																<hr />

																																{
																																	row?.bookedRate && (
																																		<Row>
																																			<Col md={6} class="detail-info row">
																																				<Row>
																																					<Col md={6}>Booked Rate</Col>
																																					<Col md={6}>
																																						{" "}
																																						{
																																							!row.bookedRate || row.bookedRate == "" || row.bookedRate == "0.00" || row.bookedRate == "0" || row.bookedRate == "0.0" || row.bookedRate == "0.000" || row.bookedRate == "undefined"
																																								? "-"
																																								: `${row.bookedRate}`
																																						}
																																					</Col>
																																				</Row>
																																			</Col>
																																		</Row>
																																	)
																																}


																																{(row.studentId || row.consumerName || row.consumerEmail ||
																																	row.consumerPhone || row.consumerCountry || row.paymentReference) && (
																																		< Row >
																																			<Col md={12}>
																																				<Typography
																																					variant="h6"
																																					component="div"
																																					className="mt-3"
																																					style={{
																																						fontSize: "1.4rem",
																																					}}
																																				>
																																					Student Info
																																				</Typography>
																																				<hr />
																																				<Row>
																																					<Col md={6} class="detail-info row">
																																						<Row>
																																							<Col md={6}>Student ID</Col>
																																							<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{row.studentId || "-"}</Col>
																																						</Row>
																																					</Col>
																																					<Col md={6} class="detail-info row">
																																						<Row>
																																							<Col md={6}>Student Name</Col>
																																							<Col md={6}>{row.consumerName || "-"}</Col>

																																						</Row>


																																					</Col>

																																				</Row>
																																				<hr />
																																				<Row>
																																					<Col md={6} class="detail-info row">
																																						<Row>
																																							<Col md={6} >Student Email</Col>
																																							<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{row.consumerEmail || "-"}</Col>
																																						</Row>
																																					</Col>
																																					<Col md={6} class="detail-info row">
																																						<Row>
																																							<Col md={6}>Student Phone</Col>
																																							<Col md={6}>
																																								{!row.consumerPhone || row.consumerPhone === ""
																																									? "-"
																																									: row.consumerPhone}
																																							</Col>
																																						</Row>

																																					</Col>

																																				</Row>
																																				<hr />
																																				<Row>
																																					<Col md={6} class="detail-info row">
																																						<Row>
																																							<Col md={6}>Student Country</Col>
																																							<Col md={6}>{row.consumerCountry || "-"}</Col>
																																						</Row>
																																					</Col>
																																					<Col md={6} class="detail-info row">
																																						<Row>
																																							<Col md={6} >Payment Reference</Col>
																																							<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{row.paymentReference || "-"}</Col>
																																						</Row>
																																					</Col>

																																				</Row>
																																			</Col>
																																		</Row>)}


																																{historyList.length > 0 && (
																																	<>
																																		<Typography
																																			variant="h6"
																																			component="div"
																																			className="mt-3"
																																			style={{
																																				fontSize: "1.4rem",
																																				// paddingTop: "3.5%",
																																				// paddingBottom: "1.5%",
																																			}}
																																		>
																																			Transaction History
																																		</Typography>
																																		<hr />

																																		<div className="ViewTranHistory" style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto" }}>
																																			<TableContainer component={Paper} style={{ minWidth: "700px" }}>
																																				<Table
																																					className={classes.table}
																																					aria-label="a dense table"
																																					style={{ whiteSpace: "nowrap" }}
																																				>
																																					<TableHead>
																																						<TableRow className="">
																																							<TableCell
																																								align="center"
																																								style={{ color: "black" }}
																																							>
																																								Action{" "}
																																							</TableCell>
																																							<TableCell
																																								align="center"
																																								style={{ color: "black" }}
																																							>
																																								Timestamp
																																							</TableCell>
																																							<TableCell
																																								align="center"
																																								style={{ color: "black" }}
																																							>
																																								Transaction Type
																																							</TableCell>
																																							<TableCell
																																								align="center"
																																								style={{ color: "black" }}
																																							>
																																								Amount
																																							</TableCell>
																																							<TableCell
																																								align="center"
																																								style={{ color: "black" }}
																																							>
																																								Currency
																																							</TableCell>
																																							<TableCell
																																								align="center"
																																								style={{ color: "black" }}
																																							>
																																								Remark
																																							</TableCell>
																																						</TableRow>
																																					</TableHead>
																																					<TableBody>
																																						{historyList?.length > 0 ? (
																																							historyList.map((item, index) => (
																																								<TableRow key={index}>
																																									<TableCell align="center">
																																										{item.status || "-"}
																																									</TableCell>

																																									<TableCell align="center">
																																										{item.timestamp || "-"}
																																									</TableCell>

																																									<TableCell align="center">
																																										{item.transactionType
																																											? getTransactionHistoryTypeLabel(item.transactionType)
																																											: "-"}
																																									</TableCell>

																																									<TableCell align="center">
																																										{item.amount || "-"}
																																									</TableCell>

																																									<TableCell align="center">
																																										{item.currency || "-"}
																																									</TableCell>

																																									<TableCell align="center">
																																										{item.remark || "-"}
																																									</TableCell>
																																								</TableRow>
																																							))
																																						) : (
																																							<TableRow>
																																								<TableCell colSpan={6} align="center">
																																									No Transaction History Found
																																								</TableCell>
																																							</TableRow>
																																						)}
																																					</TableBody>
																																				</Table>
																																			</TableContainer>
																																		</div>

																																	</>
																																)}



																																{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.payerType == "Other" ? (
																																	<Row>
																																		<Col md={12}>
																																			<Typography
																																				variant="h6"
																																				component="div" x
																																				className="mt-3"
																																				style={{
																																					fontSize: "1.4rem",
																																					paddingBottom: "1%"
																																				}}
																																			>
																																				{("Payer Details")}
																																			</Typography>

																																			<hr />

																																			<Row className="detail-info">
																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Full Name")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails.name || "-"}
																																						</Col>
																																					</Row>
																																				</Col>

																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Date of Birth")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.dob || "-"}
																																						</Col>
																																					</Row>
																																				</Col>
																																			</Row>

																																			<hr />

																																			<Row className="detail-info">
																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Email")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.email || "-"}
																																						</Col>
																																					</Row>
																																				</Col>

																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Contact No")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.contactNo || "-"}
																																						</Col>
																																					</Row>
																																				</Col>
																																			</Row>

																																			<hr />

																																			<Row className="detail-info">
																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Address")}</Col>
																																						<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }} >
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.address || "-"}
																																						</Col>
																																					</Row>
																																				</Col>

																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Country of Residence")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.country || "-"}
																																						</Col>
																																					</Row>
																																				</Col>
																																			</Row>

																																			<hr />

																																			<Row className="detail-info">
																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Nationality")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.nationality || "-"}
																																						</Col>
																																					</Row>
																																				</Col>

																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Relationship to Student")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.relationshipToStudent || "-"}
																																						</Col>
																																					</Row>
																																				</Col>
																																			</Row>

																																			<hr />

																																			<Row className="detail-info">
																																				<Col md={6}>
																																					<Row>
																																						<Col md={6}>{("Payer Type")}</Col>
																																						<Col md={6}>
																																							{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO?.payerDetails?.payerType || "-"}
																																						</Col>
																																					</Row>
																																				</Col>
																																			</Row>


																																		</Col>
																																	</Row>

																																) : ""}



																																{/* {partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Offline Bank Transfer" &&
																																	<Row>
																																		<Col md={6} class="detail-info row">
																																			<Row>
																																				<Col md={6}>Exchange Rate </Col>
																																				<Col md={6}>
																																					{" "}
																																					1 GBP = {
																																						!row.convertedRate || row.convertedRate == ""
																																							? "-"
																																							: `${row.convertedRate} ${row.convertedCurrency}`
																																					}
																																				</Col>
																																			</Row>
																																		</Col>
																																		<Col md={6} class="detail-info row">
																																			<Row>

																																				<Col md={6}>Converted Amount </Col>
																																				<Col md={6}>
																																					{" "}
																																					{
																																						!row.convertedAmount || row.convertedAmount == ""
																																							? "-"
																																							: `${row.convertedAmount} ${row.convertedCurrency}`
																																					}
																																				</Col>
																																			</Row>
																																		</Col>
																																	</Row>
																																} */}


																																{/* <hr /> */}

																																{/* {row.transactionType === "REFUND" ? (
																																	<>
																																		{/* <hr /> */}

																																{/* <Row>
																																			<Col
																																				md={6}
																																				class="detail-info row"
																																			>
																																				<Row>
																																					<Col md={6}>Parent ID</Col>
																																					<Col md={6}>
																																						<Typography
																																							style={{
																																								color: "blue",
																																								cursor: "pointer",
																																								fontWeight: "bold",
																																								color: "blue",
																																							}}
																																							onClick={() => {

																																								handleParentOpen(
																																									row.parentId
																																								);
																																							}}
																																						>
																																							{" "}
																																							{!row.parentId ||
																																								row.parentId == ""
																																								? "-"
																																								: row.parentId}
																																						</Typography>
																																					</Col>
																																				</Row>
																																			</Col>

																																			{row.isRefundDisplay === "Y" && refundFlag ? (
																																				<Col
																																					md={6}
																																					class="detail-info row"
																																				>
																																					<Row>


																																						<Col md={6}>
																																							<Typography
																																								style={{
																																									color: "Blue",
																																									margin: "0px",
																																								}}
																																								// variant="contained"
																																								onClick={() => {
																																									setGetRefundOpenModal(true);;
																																								}}
																																							>
																																								Refund Details
																																							</Typography>
																																						</Col>
																																			
																																					</Row>
																																				</Col>
																																			) : (
																																				""
																																			)}
																																		</Row>
																																	</>
																																) : (
																																	""
																																)} */}
																																{/* {row.transactionType !== "REFUND" &&
																																	row.isRefundDisplay === "Y" && refundFlag && (
																																		<>
																																			{/* <hr /> */}


																																{/* <Row>
																																				<Col md={6}>
																																					<Typography
																																						style={{
																																							color: "Blue",
																																							margin: "0px",
																																							cursor: "pointer"
																																						}}
																																						// variant="contained"
																																						onClick={() => { setGetRefundOpenModal(true); }}
																																					// onClick={() => { getRefundDetailsPartnerReq(row.walletOwnerId, row.transactionId); }}
																																					>
																																						Refund Details
																																					</Typography>
																																				</Col>
																																			</Row>
																																		</>
																																	)} */}
																																{/* {row.isFee === "Yes" ? (
																																	<Col
																																		md={6}
																																		class="detail-info row"
																																	>
																																		<Row>
																																			<Col md={6} style={{padding:"10px 0 0 0"}}>
																																			<Typography
																																						style={{
																																							color: "Blue",
																																							fontWeight:"600",
																																							cursor: "pointer",
																																							
																																						
																																						}}
																																						// variant="contained"
																																						// onClick={() => { setGetRefundOpenModal(true); }}
																																					onClick={() => { handleFeeDetailsOpen(row.walletOwnerId, row.transactionId); }}
																																					>
																																					Fee Details
																																					</Typography>
																																				
																																			</Col>

																																		</Row>
																																	</Col>
																																) : (
																																	""
																																)} */}

																																{/* <hr /> */}
																																{/* {(row.feeType === 'No' || row.feeType === '') ? '' :
																																	<Row>
																																		<Col md={6} class="detail-info row">
																																			<Row>

																																				<Col md={6}>Fee Type</Col>
																																				<Col md={6}>
																																					{" "}
																																					{!row.feeType || row.feeType == ""
																																						? "-"
																																						: row.feeType}
																																				</Col>
																																			</Row>
																																		</Col>

																																	</Row>
																																}
																																{(row.feeType === 'No' || row.feeType === '') ? "" :
																																	<hr />} */}
																															</Col>
																														</Row>







																													</Col>

																												</Row>
																												{
																													(
																														(row.firstSix && row.firstSix !== '-') ||
																														(row.lastFour && row.lastFour !== '-') ||
																														(row.cardHolderName && row.cardHolderName !== '-') ||
																														(row.binCountry && row.binCountry !== '-')
																													) && (
																														<Row>
																															<Col md={12}>
																																<Typography
																																	variant="h6"
																																	component="div"
																																	className="mt-3"
																																	style={{ fontSize: "1.4rem" }}
																																>
																																	Account Details
																																</Typography>
																																<hr />

																																{/* ACCOUNT HOLDER */}
																																<Row>
																																	<Col md={6} >
																																		<Row>
																																			<Col md={6}>Account Holder</Col>
																																			<Col md={6}>
																																				{row.cardHolderName ? row.cardHolderName : "-"}
																																			</Col>
																																		</Row>
																																	</Col>

																																	{/* NET BANKING CONDITION HERE ↓↓↓ */}
																																	{partnerGetWalletTransactionListByIdRes?.data?.transactionMasterDetailsResponseVO.transactionSubType === "Net Banking" ? (
																																		<Col md={6} className="detail-info row">
																																			<Row>
																																				<Col md={6}>Account</Col>
																																				<Col md={6}>{row.bankName || "-"}</Col>
																																			</Row>
																																		</Col>
																																	) : (
																																		<Col md={6} className="detail-info row">
																																			<Row>
																																				<Col md={6}>Account Number</Col>
																																				<Col md={6}>
																																					{row.firstSix === "-" || row.firstSix === "" ||
																																						row.lastFour === "-" || row.lastFour === ""
																																						? "-"
																																						: `${row.firstSix}-XXXXXX-${row.lastFour}`}
																																				</Col>
																																			</Row>
																																		</Col>
																																	)}
																																</Row>

																																<hr />

																																{/* BIN COUNTRY */}
																																<Row>
																																	<Col md={6} className="detail-info row">

																																		<Col md={6}>Bin Country</Col>
																																		<Col md={6}>
																																			{row.binCountry && row.binCountry !== "-" && (
																																				<img
																																					src={countryFlagS(row.binCountry)}
																																					style={{
																																						height: "20px",
																																						width: "20px",
																																						marginRight: "10px"
																																					}}
																																					alt={`${row.binCountry} flag`}
																																				/>
																																			)}
																																			{row.binCountry || "-"}
																																		</Col>

																																	</Col>
																																</Row>
																															</Col>
																														</Row>
																													)
																												}

																												{/* {(row.firstSix === '-' || row.firstSix === '') && (row.lastFour === '-' || row.lastFour === '') &&
																													(row.cardHolderName === '-' || row.cardHolderName === '')
																													&& (row.binCountry === '-' || row.binCountry === '')
																													? '' :
																													<Row>
																														<Col md={12}>
																															<Typography
																																variant="h6"
																																component="div"
																																className="mt-3"
																																style={{
																																	fontSize: "1.4rem",
																																}}
																															>
																																Account Details
																															</Typography>
																															<hr />
																															<Row >
																																<Col md={6} class="detail-info row">
																																	<Row>

																																		<Col md={6}>Account Holder</Col>
																																		<Col md={6}>
																																			{!row.cardHolderName || row.cardHolderName == ""
																																				? "-"
																																				: row.cardHolderName}

																																		</Col>
																																	</Row>
																																</Col>
																																<Col md={6} class="detail-info row">
																																	<Row>

																																		<Col md={6}>Account Number</Col>
																																		<Col md={6}> */}
																												{/* {!row.firstSix + "xxxx" + !row.lastFour ||
																											row.firstSix + "xxxx" + row.lastFour === "" ? "-"
																											: row.firstSix + "xxxx" + row.lastFour} */}
																												{/* {!row.firstSix + !row.lastFour ||
																																				row.firstSix + row.lastFour === "" ? "-"
																																				: row.firstSix + "-" + "XXXXXX" + "-" + row.lastFour}

																																		</Col>
																																	</Row>
																																</Col> */}
																												{/* <Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>Bin Country</Col>
																									<Col md={6}>

																										{!row.binCountry || row.binCountry == ""
																											? "-"
																											: row.binCountry}

																									</Col>
																								</Row>
																							</Col> */}
																												{/* </Row>
																															<hr /> */}

																												{/* <Row>
																																<Col md={6} class="detail-info row">
																																	<Row>

																																		<Col md={6}>Bin Country</Col>
																																		<Col md={6}> */}
																												{/* {row.binCountry && row.binCountry === "-" ? "" :
																																				(<img src={countryFlagS(row.binCountry)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)}
																																			{!row.binCountry || row.binCountry === "" ? "-" : row.binCountry} */}
																												{/* {row.binCountry && row.binCountry !== "-" && (
																																				<img
																																					src={countryFlagS(row.binCountry)}
																																					style={{ height: "20px", width: "20px", marginRight: "10px" }}
																																					alt={`${row.binCountry} flag`}
																																				/>
																																			)}
																																			{!row.binCountry || row.binCountry === "" ? "-" : row.binCountry}
																																		</Col> */}
																												{/* <Col md={6}>
																										{!row.binCountry || row.binCountry == ""
																											? "-"
																											: row.binCountry}
																									</Col> */}
																												{/* </Row>
																																</Col>
																															</Row> */}
																												{/* <Row >
																							<Col md={6} class="detail-info row">
																								<Row>

																									<Col md={6}>First Six</Col>
																									<Col md={6}>
																										{!row.firstSix || row.firstSix == ""
																											? "-"
																											: row.firstSix}
																									</Col>
																								</Row>
																							</Col>
																							<Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>Last Four</Col>
																									<Col md={6}>
																										{!row.lastFour || row.lastFour == ""
																											? "-"
																											: row.lastFour}
																									</Col>
																								</Row>
																							</Col>
																						</Row>
																						<hr /> */}
																												{/* 
																														</Col>
																													</Row>
																												} */}

																												{(row.deviceFingerPrint === '-' || row.deviceFingerPrint === '') && (row.customerIp === '-' || row.customerIp === '') ? '' :

																													<Row>
																														<Col md={12}>
																															<Typography
																																variant="h6"
																																component="div"
																																className="mt-3"
																																style={{
																																	fontSize: "1.4rem",
																																}}
																															>
																																Device Info
																															</Typography>
																															<hr />
																															<Row>

																																{/* <Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>IP Address</Col>
																									<Col md={6}>
																										{" "}
																										{!row.customerIp || row.customerIp == ""
																											? "-"
																											: row.customerIp}
																									</Col>
																								</Row>
																							</Col> */}
																																<Col md={6} class="detail-info row">
																																	{/* <Row> */}
																																	{/* <Col md={6}>IP Country</Col> */}
																																	{/* <Col md={6}>
																										{" "}
																										{!row.ipFlag || row.ipFlag == ""
																											? "-"
																											: row.ipFlag}
																									</Col> */}
																																	{/* <Col md={6}>
																										{row.ipFlag && row.ipFlag === "-" ? "" :
																											(<img src={countryFlag(row.ipFlag)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)}
																									</Col> */}
																																	{/* </Row> */}
																																	<Row>
																																		<Col md={6}>IP Address</Col>
																																		<Col md={6}>
																																			{row.ipFlag && row.ipFlag === "-" ? "" :
																																				(<img src={countryFlag(row.ipFlag)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)}
																																			{!row.customerIp || row.customerIp == "" ? "-" : row.customerIp}</Col>
																																	</Row>
																																</Col>
																																<Col md={6} class="detail-info row">
																																	<Row>
																																		<Col md={6}>Device</Col>
																																		<Col md={6}>
																																			{" "}
																																			{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device : "-"}
																																		</Col>
																																	</Row>
																																</Col>

																															</Row>
																															<hr />
																															<Row >
																																<Col md={6} class="detail-info row">
																																	<Row>
																																		<Col md={6}>Device Density</Col>
																																		<Col md={6}>
																																			{" "}
																																			{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Density != "" ? JSON.parse(`${row.deviceFingerPrint}`).Density : "-"}
																																		</Col>
																																	</Row>
																																</Col>
																																<Col md={6} class="detail-info row">
																																	<Row>
																																		<Col md={6}>Device Memory</Col>
																																		<Col md={6}>
																																			{" "}
																																			{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device_Memory != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device_Memory : "-"}
																																		</Col>
																																	</Row>
																																</Col>
																																{/* <Col md={6} class="detail-info row">
																								<Row>
																									<Col md={6}>Device</Col>
																									<Col md={6}>
																										{" "}
																										{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device : "-"}
																									</Col>
																								</Row>
																							</Col> */}
																															</Row>
																															<hr />
																															<Row>

																																<Col md={6} class="detail-info row">
																																	<Row>
																																		<Col md={6}>Device UUID</Col>
																																		<Col md={6}>
																																			{" "}
																																			{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).Device_UUID != "" ? JSON.parse(`${row.deviceFingerPrint}`).Device_UUID : "-"}
																																		</Col>
																																	</Row>
																																</Col>
																																<Col md={6} class="detail-info row">
																																	<Row>
																																		<Col md={6}>OS</Col>
																																		<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
																																			{" "}
																																			{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).OS != "" ? JSON.parse(`${row.deviceFingerPrint}`).OS : "-"}
																																		</Col>
																																	</Row>
																																</Col>
																															</Row>
																															<hr />
																															<Row >


																																<Col md={6} class="detail-info row">
																																	<Row>
																																		<Col md={6}>OS Version</Col>
																																		<Col md={6} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
																																			{" "}
																																			{row.deviceFingerPrint && row.deviceFingerPrint != "-" && JSON.parse(`${row.deviceFingerPrint}`).OS_Version != "" ? JSON.parse(`${row.deviceFingerPrint}`).OS_Version : "-"}
																																		</Col>
																																	</Row>
																																</Col>

																															</Row>


																														</Col>
																													</Row>
																												}

																											</TableRow>

																										))}
																							</TableBody>
																						</Table>
																					)}
																				</>
																			) : (
																				""
																			)}
																		</Box>
																	</Collapse>
																</TableCell >
															</TableRow>
														</>
													))}
										</TableBody>
									</Table >
									{/* {console.log("PAGINATION Parameter", rowsPerPage, pageNo, getWalletTransactionListRes.data.count)} */}
									{/* <CustomPaginationActionsTable
										count={getWalletTransactionListRes.data.count}
										initialRowsPerPage={rowsPerPage}
										initialpage={pageNo}
										handleChangePage={(_, p) => handleChangePageForward(_, p)}
										handleChangeRowsPerPage={handleChangeRowsPerPage}
									/> */}
									< TablePagination
										rowsPerPageOptions={[5, 10, 25]}

										component="div"
										count={Number(getWalletTransactionListRes.data.count)}
										rowsPerPage={rowsPerPage}
										page={pageNo}
										// ActionsComponent={TablePaginationActions}
										onPageChange={handleChangePageForward}
										onRowsPerPageChange={handleChangeRowsPerPage}
									// handleChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)}
				</Layout >
				<div>
					<Dialog open={viewOpen} onClose={closeEditModal}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Transaction Summary
						</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="To Customer Contact"
								fullWidth={true}
								name="toCustContact"
								value={toCustContact || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="To Customer Name"
								fullWidth={true}
								name="toCustomerName"
								value={toCustomerName || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Balance"
								fullWidth={true}
								name="toBalance"
								value={toBalance || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Transaction Status"
								fullWidth={true}
								name="TransactionStatus"
								value={TransactionStatus || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Ip Address"
								fullWidth={true}
								name="ipAdd"
								value={ipAdd.length ? ipAdd : "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Credit"
								fullWidth={true}
								name="Credit"
								value={Credit || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Debit"
								fullWidth={true}
								name="Debit"
								value={Debit || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Remark"
								fullWidth={true}
								name="Remark"
								value={remark || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								name="Currency"
								value={toCurrency || ""}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								format="MM/dd/yyyy"
								label="Date & Time"
								fullWidth={true}
								name="fromDATE"
								value={fromDATE || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Is Fee"
								fullWidth={true}
								name="IsFees"
								value={IsFees || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Transaction Amount"
								fullWidth={true}
								name="TransactionAmt"
								value={TransactionAmt || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="From Customer Id"
								fullWidth={true}
								name="FromCustomerId"
								value={fromCustID || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="From Customer Name"
								fullWidth={true}
								name="fromCustName"
								value={fromCustName || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Device Density"
								fullWidth={true}
								name="density"
								value={density || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Device"
								fullWidth={true}
								name="device"
								value={device || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Device Memory"
								fullWidth={true}
								name="deviceMemory"
								value={deviceMemory || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Device UUID"
								fullWidth={true}
								name="deviceUUID"
								value={deviceUUID || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="OS"
								fullWidth={true}
								name="os"
								value={os || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
							<TextField
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="OS Version"
								fullWidth={true}
								name="osVersion"
								value={osVersion || "-"}
								onChange={handleChange}
								disabled
							>
							</TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									color: "white"
								}}
								variant="contained"
								onClick={closeEditModal}
							>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>


				<div>
					<Dialog open={parentDetails} onClose={closeEditModal}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Transaction Summary
						</DialogTitle>
						<DialogContent>
							<Row>
								<Col md={12}>
									<Typography
										variant="h6"
										component="div"
										className="mt-3"
										style={{
											fontSize: "1.4rem",
										}}
									>
										Customer Info
									</Typography>
									<hr />
									<Row>
										<Col md={6} class="detail-info row">
											<Row>
												<Col md={6}>From Customer</Col>
												<Col md={6}>
													{" "}
													{/* {!row.fromCustName || row.fromCustName == ""
														? "-"
														: row.fromCustName} */}
													{/* {getWalletTransactionListRes.data.transactionList} */}
													{getWalletTransactionListRes.data.transactionList && getWalletTransactionListRes.data.transactionList.fromCustName ? getWalletTransactionListRes.data.transactionList.fromCustName : "-"}

												</Col>
											</Row>
										</Col>

									</Row>

								</Col>
							</Row>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<CustomButton
								style={{
									color: "white"
								}}
								variant="contained"
								onClick={closeEditModal}
							>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={openUpdateModal} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Update Details</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								// select
								size="small"
								color="primary"
								// autoFocus={true}
								type="text"
								label="Transaction ID"
								fullWidth={true}
								name="orgnDesc"
								value={orgnDesc || ""}
								onChange={handleChange}
								variant="standard"
								disabled
							/>
							<TextField
								style={{ marginTop: "10px" }}
								// select
								size="small"
								color="primary"
								// autoFocus={true}
								type="text"
								label="Payment ID"
								fullWidth={true}
								name="paymentId"
								value={paymentid || ""}
								onChange={handleChange}
								variant="standard"
							/>
							<TextField
								select
								autoFocus
								margin="dense"
								label="Status"
								name="updateStatus"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}


								defaultValue={updateStatus || "Select Status"}
							>
								<MenuItem value="Success">Success</MenuItem>
								<MenuItem value="Failed">Failed</MenuItem>
								{/* <MenuItem value="Pending">Pending</MenuItem> */}

							</TextField>

							<TextField
								autoFocus
								margin="dense"
								label="Remark"
								name="getRemark"
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={getRemark || ""}
								inputProps={{
									// Extra safety: prevent paste of invalid characters
									onPaste: (e) => {
										const paste = e.clipboardData.getData("text");
										const allowedPattern = /^[a-zA-Z0-9 '"\\-]*$/;
										if (!allowedPattern.test(paste)) {
											e.preventDefault();
										}
									}
								}}
							/>
							{/* <TextField
							select
							autoFocus
							margin="dense"
							label="Status"
							name="updateStatus"
							type="text"
							fullWidth
							variant="standard"
							onChange={handleChange}
							defaultValue={updateStatus || "Select Status"}
						>
							<MenuItem value="Success">Success</MenuItem>
							<MenuItem value="Failed">Failed</MenuItem>
							<MenuItem value="Pending">Pending</MenuItem>

						</TextField> */}
						</DialogContent>
						<DialogActions>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								disabled={!getRemark && !updateStatus}
								onClick={getUpdateGateWayReq}
							>
								Update
							</CustomButton>

						</DialogActions>
					</Dialog>
				</div>

				{
					(viewUpdateResArray.status === "success" || viewUpdateResArray.status === "Success") && (
						<div>
							<Dialog
								open={notificationRefundOpen}
								onClose={handleNoticationClose}
							>
								<DialogContent
									className="text-center"
									style={{ backgroundColor: "#00b9f51c" }}
								>
									<img src={success} alt="" width="100px" className="my-2" />
								</DialogContent>
								<DialogContent>
									<h4
										style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
									>
										{viewUpdateResArray.description}
									</h4>
								</DialogContent>
								<DialogActions style={{ justifyContent: "center" }}>
									<Button
										style={{
											margin: "10px 0",
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										variant="contained"
										onClick={handleNoticationClose}
									>
										Ok
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					)
				}
				{
					viewUpdateResArray.status == "Failed" && (
						<div>
							<Dialog
								open={notificationRefundOpen}
								onClose={handleNoticationClose}
							>
								<DialogContent
									className="text-center"
									style={{ backgroundColor: "#00b9f51c" }}
								>
									<img src={failed} alt="" width="100px" className="my-2" />
								</DialogContent>
								<DialogContent>
									<h4
										style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
									>
										{viewUpdateResArray.description}
									</h4>
								</DialogContent>
								<DialogActions style={{ justifyContent: "center" }}>
									<Button
										style={{
											margin: "10px 0",
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										variant="contained"
										onClick={handleNoticationClose}
									>
										Ok
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					)
				}
				{
					viewUpdateResArray.status == "failed" && (
						<div>
							<Dialog
								open={notificationRefundOpen}
								onClose={handleNoticationClose}
							>
								<DialogContent
									className="text-center"
									style={{ backgroundColor: "#00b9f51c" }}
								>
									<img src={failed} alt="" width="100px" className="my-2" />
								</DialogContent>
								<DialogContent>
									<h4
										style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
									>
										{viewUpdateResArray.description}
									</h4>
								</DialogContent>
								<DialogActions style={{ justifyContent: "center" }}>
									<Button
										style={{
											margin: "10px 0",
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										variant="contained"
										onClick={handleNoticationClose}
									>
										Ok
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					)
				}
			</>




			{(getRefundOpenModal && (partnerGetRefundDetailsRes.data.status !== "Success" || partnerGetRefundDetailsRes.data.status !== "success")) && <Dialog open={getRefundOpenModal} onClose={handleClose} >
				{partnerGetRefundDetailsRes.data.status == "failed" || partnerGetRefundDetailsRes.data.status == "Failed" ? <DialogContent >
					<DialogContent style={{ display: "flex", justifyContent: "center" }} >    <img src={failed} alt="" width="100px" className="my-2" /></DialogContent>
					<DialogContent >{partnerGetRefundDetailsRes.data.description}</DialogContent></DialogContent> : ""}

				<DialogActions className="p-3">
					<CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
						Close
					</CustomButton>
				</DialogActions> </Dialog>}



			<div>
				{((getRefundOpenModal && (partnerGetRefundDetailsRes.data.status == "Success" || partnerGetRefundDetailsRes.data.status == "success")) && (partnerGetRefundDetailsRes.data.status !== "Success" || partnerGetRefundDetailsRes.data.status !== "success")) && (
					<Dialog open={getRefundOpenModal} onClose={handleClose} maxWidth="md" fullWidth>
						<DialogTitle>Refund Details</DialogTitle>
						<DialogContent dividers>
							<TableContainer component={Paper} style={{ overflow: 'hidden' }}>
								<Table>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Transaction Id
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Currency
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Amount
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Status
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Transaction Sub-Type
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Remark
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Date
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{partnerGetRefundDetailsRes.data.Response && [].concat(partnerGetRefundDetailsRes.data.Response).map((row) => {
											return <TableRow>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.transactionId}
												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.currency}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.amount}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.status}
												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.transactionSubType}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.remark}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.registeredTime.split(" ")[0]}

												</TableCell>
											</TableRow>
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</DialogContent>
						<DialogActions className="p-3">
							<CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				)}
			</div>

			<div>
				{((getFeeDetailsOpenModal && (partnerGetFeeDetailsByIDRes.data.status == "success" || partnerGetFeeDetailsByIDRes.data.status == "success")) && (partnerGetFeeDetailsByIDRes.data.status !== "Success" || partnerGetFeeDetailsByIDRes.data.status !== "success")) && (
					<Dialog open={getFeeDetailsOpenModal} onClose={handleClose} fullWidth maxWidth="md">
						<DialogTitle>Fee Details</DialogTitle>
						<DialogContent dividers style={{ maxHeight: '70vh', overflowY: 'auto' }}>
							<TableContainer component={Paper}>
								<Table>
									<TableHead>
										<TableRow className="themeBackground">
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Transaction Id
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Currency
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Amount
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Status
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Transaction Sub-Type
											</TableCell>

											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Remark
											</TableCell>

											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Status Description
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Fee Type
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Date
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												From Customer
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Receiver
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{partnerGetFeeDetailsByIDRes.data.Response && [].concat(partnerGetFeeDetailsByIDRes.data.Response).map((row) => {
											return <TableRow>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.id}
												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.currency}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.amount}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.status}
												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.transactionSubType}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.remark}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.statusDescription}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.feeType}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.registeredTime.split(" ")[0]}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.fromCustName}

												</TableCell>
												<TableCell align="center" style={{ borderBottom: "0" }}>
													{row.toCustName}

												</TableCell>
											</TableRow>
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</DialogContent>
						<DialogActions className="p-3">
							<CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				)}
			</div>




			<div>
				<Dialog open={parentIdModal} onClose={() => setparentIdModal(false)}>
					<DialogTitle style={{ minWidth: "600px" }}>
						Parent Transaction Details
					</DialogTitle>
					<DialogContent>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Transaction ID"
								fullWidth={true}
								name="transactionId"
								value={parentDetailsArr.transactionId || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Amount"
								fullWidth={true}
								name="amount"
								value={parentDetailsArr.amount || "-"}
							/>
						</div>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Status"
								fullWidth={true}
								name="status"
								value={parentDetailsArr.status || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Transaction Type"
								fullWidth={true}
								name="transactionType"
								value={parentDetailsArr.transactionType || "-"}
							/>
						</div>
						<TextField
							style={{ margin: "10px 4px 0" }}
							size="small"
							type="text"
							disabled
							label="Transaction Date"
							fullWidth={true}
							name="registeredTime"
							value={parentDetailsArr.registeredTime || "-"}
						/>
						<h1 style={{ marginTop: "1.5rem", marginBottom: "8px", fontSize: "16px", fontWeight: "600", borderBottom: "1px solid #dee2e6", paddingBottom: "8px" }}
							className="accordionDiv"
						> Customer Info </h1>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="From Customer"
								fullWidth={true}
								name="fromCustName"
								value={parentDetailsArr.fromCustName || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="From Customer Contact"
								fullWidth={true}
								name="fromContact"
								value={parentDetailsArr.fromContact || "-"}
							/>
						</div>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Benificiary"
								fullWidth={true}
								name="toCustName"
								value={parentDetailsArr.toCustName || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Benificiary Contact"
								fullWidth={true}
								name="toCustomerContact"
								value={parentDetailsArr.toCustomerContact || "-"}
							/>
							{/* <Input
								type={hiddenPassword ? "password" : "text"}
								id="fromCustContact"
								label="From Customer Contact"
								name="toCustomerContact"
								fullWidth
								value={parentDetailsArr.toCustomerContact}
								endAdornment={
								<InputAdornment position="end">
									<IconButton
									onClick={toggleShow}
									>
									{hiddenPassword ? (
										<VisibilityOff />
									) : (
										<Visibility />
									)}
									</IconButton>
								</InputAdornment>
								}
							/> */}
						</div>
						<h1 style={{ marginTop: "1.5rem", marginBottom: "8px", fontSize: "16px", fontWeight: "600", borderBottom: "1px solid #dee2e6", paddingBottom: "8px" }} > Transaction Info </h1>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="From Wallet"
								fullWidth={true}
								name="fromWallet"
								value={parentDetailsArr.fromWallet ? parentDetailsArr.fromWallet.split(' ')[0] : '-' || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="To Wallet"
								fullWidth={true}
								name="toWallet"
								value={parentDetailsArr.toWallet ? parentDetailsArr.toWallet.split(' ')[0] : '-' || "-"}
							/>
						</div>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Transaction Sub Type"
								fullWidth={true}
								name="transactionSubType"
								value={parentDetailsArr.transactionSubType || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Order Reference"
								fullWidth={true}
								name="orderDescription"
								value={parentDetailsArr.orderDescription || "-"}
							/>
						</div>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Status Description"
								fullWidth={true}
								name="statusDescription"
								value={parentDetailsArr.statusDescription || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Remark"
								fullWidth={true}
								name="remark"
								value={parentDetailsArr.remark || "-"}
							/>
						</div>
						<div style={{ display: 'flex' }}>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Status Description"
								fullWidth={true}
								name="statusDescription"
								value={parentDetailsArr.statusDescription || "-"}
							/>
							<TextField
								style={{ margin: "10px 4px 0" }}
								size="small"
								type="text"
								disabled
								label="Remark"
								fullWidth={true}
								name="remark"
								value={parentDetailsArr.remark || "-"}
							/>
						</div>
						{
							(!parentDetailsArr.cardHolderName || parentDetailsArr.cardHolderName === '' || parentDetailsArr.cardHolderName === '-') &&
								(!parentDetailsArr.firstSix || parentDetailsArr.firstSix === '' || parentDetailsArr.firstSix === '-') &&
								(!parentDetailsArr.lastFour || parentDetailsArr.lastFour === '' || parentDetailsArr.lastFour === '-') &&
								(!parentDetailsArr.binCountry || parentDetailsArr.binCountry === '' || parentDetailsArr.binCountry === '-') ? '' : (
								<>
									<h1 style={{ marginTop: "1.5rem", marginBottom: "8px", fontSize: "16px", fontWeight: "600", borderBottom: "1px solid #dee2e6", paddingBottom: "8px" }} > Account Details </h1>
									<div style={{ display: 'flex' }}>
										<TextField
											style={{ margin: "10px 4px 0" }}
											size="small"
											type="text"
											disabled
											label="Account Holder"
											fullWidth={true}
											name="cardHolderName"
											value={parentDetailsArr.cardHolderName || "-"}
										/>
										<TextField
											style={{ margin: "10px 4px 0" }}
											size="small"
											type="text"
											disabled
											label="Account Number"
											fullWidth={true}
											name="remark"
											value={
												(!parentDetailsArr.firstSix || parentDetailsArr.firstSix == "-") || (!parentDetailsArr.lastFour || parentDetailsArr.lastFour == "-") ?
													'-' :
													parentDetailsArr.firstSix + '-XXXXXX-' + parentDetailsArr.lastFour
													|| "-"}
										/>
									</div>
									<TextField
										style={{ margin: "10px 4px 0" }}
										size="small"
										type="text"
										disabled
										label="Bin Country"
										fullWidth={true}
										name="binCountry"
										value={
											(!parentDetailsArr.binCountry || parentDetailsArr.binCountry === '' || parentDetailsArr.binCountry === "-" ? "" :
												(<img src={countryFlag(parentDetailsArr.binCountry.replace(/(\w)(\w*)/g,
													function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); }))} style={{ height: "20px", width: "20px", marginRight: "10px" }} />)) +
												!parentDetailsArr.binCountry || parentDetailsArr.binCountry == "" ? "-" : parentDetailsArr.binCountry.replace(/(\w)(\w*)/g,
													function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })
											|| "-"}
									/>
								</>
							)
						}
						{
							(!parentDetailsArr.ip || parentDetailsArr.ip === '' || parentDetailsArr.ip === '-') ? '' : (
								<>
									<h1 style={{ marginTop: "1.5rem", marginBottom: "8px", fontSize: "16px", fontWeight: "600", borderBottom: "1px solid #dee2e6", paddingBottom: "8px" }} > Device Details </h1>
									<TextField
										style={{ margin: "10px 4px 0" }}
										size="small"
										type="text"
										disabled
										label="IP Address"
										fullWidth={true}
										name="ipAddress"
										value={
											!parentDetailsArr.ipFlag || parentDetailsArr.ipFlag === "-" ? "-" :
												(<img src={countryFlag(parentDetailsArr.ipFlag.replace(/(\w)(\w*)/g,
													function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); }))} style={{ height: "20px", width: "20px", marginRight: "10px" }} />) +
													!parentDetailsArr.ip || parentDetailsArr.ip == "" ? "-" : parentDetailsArr.ip
												|| "-"}
									/>
								</>
							)
						}
					</DialogContent>
					<DialogActions style={{ justifyContent: "end" }}>
						<CustomButton
							color="primary"
							style={{ padding: '6px 8px', borderRadius: '4px' }}
							type="submit"
							onClick={() => setparentIdModal(false)}
						>
							Ok
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>



		</>
	);
};

export default WalletTransaction;